/* eslint-disable react/sort-comp,react/no-unused-prop-types */
/* @flow */

import React, { Component } from 'react';
import Helmet from 'react-helmet';
import axios from 'axios';
import { connect } from 'react-redux';
import ReactConfirmAlert, { confirmAlert } from 'react-confirm-alert';
import Beforeunload from 'react-beforeunload';
import 'react-confirm-alert/src/react-confirm-alert.css';
import _ from 'lodash';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import { Progress } from './QuestionnaireSteps/Progress/index';
import { QuestionnaireSteps } from './QuestionnaireSteps/index';
import * as action from '../FundForm/action';
// ACCEL STEPS 
import { ProgressAccel } from './QuestionnaireStepsAccel/Progress/index';
import { QuestionnaireStepsAccel } from './QuestionnaireStepsAccel/index';
import * as utility from './../../utils/utility';
import { ProgressAccelEtpnReturning } from './QuestionnaireStepsAccelEtpnReturning/Progress';
import { QuestionnaireStepsAccelEtpnReturning } from './QuestionnaireStepsAccelEtpnReturning/index';
import { QuestionnaireStepsAltimeterAML } from './QuestionnaireStepsAltimeterAML/index';
import Popup from '../../components/Popup/index';

import InstructionsPageLP from './Versions/LP/Instructions/index';
import GeneralInfoPageLP from './Versions/LP/GeneralInformation/index';
import QuestionnairePageLPv1 from './Versions/LP/v1/QuestionnaireForm/index';
import QuestionnairePageLPv2 from './Versions/LP/v2/QuestionnaireForm/index.v2';
import QuestionnairePageLPv3 from './Versions/LP/v3/QuestionnaireForm/index.v3';
import QuestionnairePageLPv4 from './Versions/LP/v4/QuestionnaireForm/index.v4';
import GeneralInfoPageLPv4 from './Versions/LP/v4/GeneralInformation/index.v4';
import GeneralInfoPageLPv5 from './Versions/LP/v5/GeneralInformation/index.v5';
import QuestionnairePageLPv5 from './Versions/LP/v5/QuestionnaireForm/index.v5';
import GeneralInfoPageLPv6 from './Versions/LP/v6/GeneralInformation/index.v6';
import QuestionnairePageLPv6 from './Versions/LP/v6/QuestionnaireForm/index.v6';
import GeneralInfoPageLPv7 from './Versions/LP/v7/GeneralInformation/index.v7';
import QuestionnairePageLPv7 from './Versions/LP/v7/QuestionnaireForm/index.v7';
import GeneralInfoPageLPv8 from './Versions/LP/v8/GeneralInformation/index.v8';
import QuestionnairePageLPv8 from './Versions/LP/v8/QuestionnaireForm/index.v8';
import GeneralInfoPageLPv8_1 from './Versions/LP/v8_1/GeneralInformation/index.v8_1';
import QuestionnairePageLPv8_1 from './Versions/LP/v8_1/QuestionnaireForm/index.v8_1';
import GeneralInfoPageLPv9 from './Versions/LP/v9/GeneralInformation/index.v9';
import QuestionnairePageLPv9 from './Versions/LP/v9/QuestionnaireForm/index.v9';
import GeneralInfoPageLPv10 from './Versions/LP/v10/GeneralInformation/index.v10';
import QuestionnairePageLPv10 from './Versions/LP/v10/QuestionnaireForm/index.v10';
import GeneralInfoPageLPv11 from './Versions/LP/v11/GeneralInformation/index.v11';
import QuestionnairePageLPv11 from './Versions/LP/v11/QuestionnaireForm/index.v11';
import GeneralInfoPageLPv12 from './Versions/LP/v12/GeneralInformation/index.v12';
import QuestionnairePageLPv12 from './Versions/LP/v12/QuestionnaireForm/index.v12';
import GeneralInfoPageLPv13 from './Versions/LP/v13/GeneralInformation/index.v13';
import QuestionnairePageLPv13 from './Versions/LP/v13/QuestionnaireForm/index.v13';
import GeneralInfoPageLPv14Seifdune from './Versions/LP/v14_seifdune/GeneralInformation/index.v14_seifdune';
import QuestionnairePageLPv14Seifdune from './Versions/LP/v14_seifdune/QuestionnaireForm/index.v14_seifdune';
import GeneralInfoPageLPv14Nosara from './Versions/LP/v14_nosara/GeneralInformation/index.v14_nosara';
import QuestionnairePageLPv14Nosara from './Versions/LP/v14_nosara/QuestionnaireForm/index.v14_nosara';
import GeneralInfoPageLPv15 from './Versions/LP/v15/GeneralInformation/index.v15';
import QuestionnairePageLPv15 from './Versions/LP/v15/QuestionnaireForm/index.v15';

import GeneralInfoPageLPv14Teamworthy from './Versions/LP/v14_teamworthy/GeneralInformation/index.v14_teamworthy';
import QuestionnairePageLPv14Teamworthy from './Versions/LP/v14_teamworthy/QuestionnaireForm/index.v14_teamworthy';


import InstructionsPageVariant from './Versions/variant/Instructions/index';
import GeneralInfoPageVariantv1 from './Versions/variant/v1/GeneralInformation/index.v1';
import QuestionnairePageVariantv1 from './Versions/variant/v1/QuestionnaireForm/index.v1';
import GeneralInfoPageVariantv3 from './Versions/variant/v3/GeneralInformation/index.v3';
import QuestionnairePageVariantv3 from './Versions/variant/v3/index.v3';

import InstructionsPageUnionPeak from './Versions/unionPeak/Instructions/index';
import GeneralInfoPageUnionPeakv1 from './Versions/unionPeak/v1/GeneralInformation/index.v1';
import QuestionnairePageUnionPeakv1 from './Versions/unionPeak/v1/QuestionnaireForm/index.v1';
import GeneralInfoPageUnionPeakv3 from './Versions/unionPeak/v3/GeneralInformation/index.v3';
import QuestionnairePageUnionPeakv3 from './Versions/unionPeak/v3/QuestionnaireForm/index.v3';
import QuestionnaireIndexPageUnionPeakv3 from './Versions/unionPeak/v3/QuestionnaireIndex/index.v3';

import InstructionsPageOCM from './Versions/OCM/Instructions/index';
import GeneralInfoPageOCMv1 from './Versions/OCM/v1/GeneralInformation/index.v1';
import QuestionnairePageOCMv1 from './Versions/OCM/v1/QuestionnaireForm/index.v1';

import InstructionsPageSorenson from './Versions/sorenson/Instructions/index';
import GeneralInfoPageSorensonv1 from './Versions/sorenson/v1/GeneralInformation/index.v1';
import QuestionnairePageSorensonv1 from './Versions/sorenson/v1/QuestionnaireForm/index.v1';
import GeneralInfoPageSorensonv3 from './Versions/sorenson/v3/GeneralInformation/index.v3';
import QuestionnairePageSorensonv3 from './Versions/sorenson/v3/QuestionnaireForm/index.v3';
import QuestionnaireIndexPageSorensonv3 from './Versions/sorenson/v3/QuestionnaireIndex/index.v3';

import InstructionsPageFrazier from './Versions/frazier/Instructions/index';
import GeneralInfoPageLFrazierv1 from './Versions/frazier/v1/GeneralInformation/index.v1';
import QuestionnairePageFrazierv1 from './Versions/frazier/v1/QuestionnaireForm/index.v1';
import GeneralInfoPageLFrazierv2 from './Versions/frazier/v2/GeneralInformation/index.v2';
import QuestionnairePageFrazierv2 from './Versions/frazier/v2/QuestionnaireForm/index.v2';

import GeneralInfoPageLLC from './Versions/LLC/GeneralInformation/index';
import InstructionsPageLLC from './Versions/LLC/Instructions/index';
import QuestionnairePageLLCv1 from './Versions/LLC/v1/QuestionnaireForm/index';
import QuestionnairePageLLCv2 from './Versions/LLC/v2/QuestionnaireForm/index.v2';
import QuestionnairePageLLCv3 from './Versions/LLC/v3/QuestionnaireForm/index.v3';
import GeneralInfoPageLLCv3 from './Versions/LLC/v3/GeneralInformation/index.v3';
import QuestionnairePageLLCv4 from './Versions/LLC/v4/QuestionnaireForm/index.v4';
import GeneralInfoPageLLCv4 from './Versions/LLC/v4/GeneralInformation/index.v4';
import QuestionnairePageLLCv5 from './Versions/LLC/v5/QuestionnaireForm/index.v5';
import GeneralInfoPageLLCv5 from './Versions/LLC/v5/GeneralInformation/index.v5';
import QuestionnairePageLLCv6 from './Versions/LLC/v6/QuestionnaireForm/index.v6';
import GeneralInfoPageLLCv6 from './Versions/LLC/v6/GeneralInformation/index.v6';
import QuestionnairePageLLCv6_1 from './Versions/LLC/v6_1/QuestionnaireForm/index.v6_1';
import GeneralInfoPageLLCv6_1 from './Versions/LLC/v6_1/GeneralInformation/index.v6_1';
import QuestionnairePageLLCv7 from './Versions/LLC/v7/QuestionnaireForm/index.v7';
import GeneralInfoPageLLCv7 from './Versions/LLC/v7/GeneralInformation/index.v7';
import QuestionnairePageLLCv8 from './Versions/LLC/v8/QuestionnaireForm/index.v8';
import GeneralInfoPageLLCv8 from './Versions/LLC/v8/GeneralInformation/index.v8';
import QuestionnairePageLLCv9 from './Versions/LLC/v9/QuestionnaireForm/index.v9';
import GeneralInfoPageLLCv9 from './Versions/LLC/v9/GeneralInformation/index.v9';
import QuestionnairePageLLCv10 from './Versions/LLC/v10/QuestionnaireForm/index.v10';
import GeneralInfoPageLLCv10 from './Versions/LLC/v10/GeneralInformation/index.v10';
import QuestionnairePageLLCv11 from './Versions/LLC/v11/QuestionnaireForm/index.v11';
import GeneralInfoPageLLCv11 from './Versions/LLC/v11/GeneralInformation/index.v11';
import QuestionnairePageLLCv13 from './Versions/LLC/v13/QuestionnaireForm/index.v13';
import GeneralInfoPageLLCv13 from './Versions/LLC/v13/GeneralInformation/index.v13';

import InstructionsPageQuestaCapital from './Versions/QuestaCapital/Instructions/index';
import GeneralInfoPageQuestaCapital from './Versions/QuestaCapital/GeneralInformation/index';
import QuestionnairePageQuestaCapitalv1 from './Versions/QuestaCapital/v1/QuestionnaireForm/index';
import QuestionnairePageQuestaCapitalv2 from './Versions/QuestaCapital/v2/QuestionnaireForm/index.v2';
import QuestionnairePageQuestaCapitalv3 from './Versions/QuestaCapital/v3/QuestionnaireForm/index.v3';
import GeneralInfoPageQuestaCapitalv3 from './Versions/QuestaCapital/v3/GeneralInformation/index.v3';
import QuestionnairePageQuestaCapitalv4 from './Versions/QuestaCapital/v4/QuestionnaireForm/index.v4';
import GeneralInfoPageQuestaCapitalv4 from './Versions/QuestaCapital/v4/GeneralInformation/index.v4';
import QuestionnairePageQuestaCapitalv5 from './Versions/QuestaCapital/v5/QuestionnaireForm/index.v5';
import GeneralInfoPageQuestaCapitalv5 from './Versions/QuestaCapital/v5/GeneralInformation/index.v5';
import QuestionnairePageQuestaCapitalv6 from './Versions/QuestaCapital/v6/QuestionnaireForm/index.v6';
import GeneralInfoPageQuestaCapitalv6 from './Versions/QuestaCapital/v6/GeneralInformation/index.v6';
import QuestionnairePageQuestaCapitalv7 from './Versions/QuestaCapital/v7/QuestionnaireForm/index.v7';
import GeneralInfoPageQuestaCapitalv7 from './Versions/QuestaCapital/v7/GeneralInformation/index.v7';
import QuestionnairePageQuestaCapitalv8 from './Versions/QuestaCapital/v8/QuestionnaireForm/index.v8';
import GeneralInfoPageQuestaCapitalv8 from './Versions/QuestaCapital/v8/GeneralInformation/index.v8';

import InstructionsPageForesite from './Versions/Foresite/Instructions/index';
import GeneralInfoPageForesite from './Versions/Foresite/GeneralInformation/index';
import QuestionnairePageForesitev1 from './Versions/Foresite/v1/QuestionnaireForm/index';
import QuestionnairePageForesitev2 from './Versions/Foresite/v2/QuestionnaireForm/index.v2';
import QuestionnairePageForesitev3 from './Versions/Foresite/v3/QuestionnaireForm/index.v3';
import GeneralInfoPageForesitev3 from './Versions/Foresite/v3/GeneralInformation/index.v3';
import QuestionnairePageForesitev4 from './Versions/Foresite/v4/QuestionnaireForm/index.v4';
import GeneralInfoPageForesitev4 from './Versions/Foresite/v4/GeneralInformation/index.v4';
import QuestionnairePageForesitev5 from './Versions/Foresite/v5/QuestionnaireForm/index.v5';
import GeneralInfoPageForesitev5 from './Versions/Foresite/v5/GeneralInformation/index.v5';
import QuestionnairePageForesitev6 from './Versions/Foresite/v6/QuestionnaireForm/index.v6';
import GeneralInfoPageForesitev6 from './Versions/Foresite/v6/GeneralInformation/index.v6';
import QuestionnairePageForesitev7 from './Versions/Foresite/v7/QuestionnaireForm/index.v7';
import GeneralInfoPageForesitev7 from './Versions/Foresite/v7/GeneralInformation/index.v7';
import QuestionnairePageForesitev8 from './Versions/Foresite/v8/QuestionnaireForm/index.v8';
import GeneralInfoPageForesitev8 from './Versions/Foresite/v8/GeneralInformation/index.v8';

import InstructionsPageInitialized from './Versions/Initialized/Instructions/index';
import GeneralInfoPageInitialized from './Versions/Initialized/GeneralInformation/index';
import QuestionnairePageInitializedv1 from './Versions/Initialized/v1/QuestionnaireForm/index';
import QuestionnairePageInitializedv2 from './Versions/Initialized/v2/QuestionnaireForm/index.v2';
import QuestionnairePageInitializedv3 from './Versions/Initialized/v3/QuestionnaireForm/index.v3';
import GeneralInfoPageInitializedV3 from './Versions/Initialized/v3/GeneralInformation/index.v3';
import QuestionnairePageInitializedv4 from './Versions/Initialized/v4/QuestionnaireForm/index.v4';
import GeneralInfoPageInitializedV4 from './Versions/Initialized/v4/GeneralInformation/index.v4';
import QuestionnairePageInitializedv5 from './Versions/Initialized/v5/QuestionnaireForm/index.v5';
import GeneralInfoPageInitializedV5 from './Versions/Initialized/v5/GeneralInformation/index.v5';
import QuestionnairePageInitializedv6 from './Versions/Initialized/v6/QuestionnaireForm/index.v6';
import GeneralInfoPageInitializedV6 from './Versions/Initialized/v6/GeneralInformation/index.v6';
import QuestionnairePageInitializedv7 from './Versions/Initialized/v7/QuestionnaireForm/index.v7';
import GeneralInfoPageInitializedV7 from './Versions/Initialized/v7/GeneralInformation/index.v7';
import QuestionnairePageInitializedv8 from './Versions/Initialized/v8/QuestionnaireForm/index.v8';
import GeneralInfoPageInitializedV8 from './Versions/Initialized/v8/GeneralInformation/index.v8';

import InstructionsPageHCM from './Versions/HCM/Instructions/index';
import QuestionnairePageHCMv1 from './Versions/HCM/v1/QuestionnaireForm/index.v1';
import GeneralInfoPageHCMv1 from './Versions/HCM/v1/GeneralInformation/index.v1';
import QuestionnairePageHCMv2 from './Versions/HCM/v2/QuestionnaireForm/index.v2';
import GeneralInfoPageHCMv2 from './Versions/HCM/v2/GeneralInformation/index.v2';
import QuestionnairePageHCMv3 from './Versions/HCM/v3/QuestionnaireForm/index.v3';
import GeneralInfoPageHCMv3 from './Versions/HCM/v3/GeneralInformation/index.v3';
import QuestionnairePageHCMv4 from './Versions/HCM/v4/QuestionnaireForm/index.v4';
import GeneralInfoPageHCMv4 from './Versions/HCM/v4/GeneralInformation/index.v4';
import QuestionnairePageHCMv5 from './Versions/HCM/v5/QuestionnaireForm/index.v5';
import GeneralInfoPageHCMv5 from './Versions/HCM/v5/GeneralInformation/index.v5';

import InstructionsPageForesiteLabs from './Versions/ForesiteLabs/Instructions';
import QuestionnairePageForesiteLabsv1 from './Versions/ForesiteLabs/v1/QuestionnaireForm/index.v1';
import GeneralInfoPageForesiteLabsv1 from './Versions/ForesiteLabs/v1/GeneralInformation/index.v1';
import QuestionnairePageForesiteLabsv2 from './Versions/ForesiteLabs/v2/QuestionnaireForm/index.v2';
import GeneralInfoPageForesiteLabsv2 from './Versions/ForesiteLabs/v2/GeneralInformation/index.v2';
import QuestionnairePageForesiteLabsv3 from './Versions/ForesiteLabs/v3/QuestionnaireForm/index.v3';
import GeneralInfoPageForesiteLabsv3 from './Versions/ForesiteLabs/v3/GeneralInformation/index.v3';
import QuestionnairePageForesiteLabsv4 from './Versions/ForesiteLabs/v4/QuestionnaireForm/index.v4';
import GeneralInfoPageForesiteLabsv4 from './Versions/ForesiteLabs/v4/GeneralInformation/index.v4';
import QuestionnairePageForesiteLabsv5 from './Versions/ForesiteLabs/v5/QuestionnaireForm/index.v5';
import GeneralInfoPageForesiteLabsv5 from './Versions/ForesiteLabs/v5/GeneralInformation/index.v5';
import QuestionnairePageForesiteLabsv6 from './Versions/ForesiteLabs/v6/QuestionnaireForm/index.v6';
import GeneralInfoPageForesiteLabsv6 from './Versions/ForesiteLabs/v6/GeneralInformation/index.v6';
import GeneralInfoPageForesiteLabsv8 from './Versions/ForesiteLabs/v8/GeneralInformation/index.v8';
import QuestionnairePageForesiteLabsv8 from './Versions/ForesiteLabs/v8/QuestionnaireForm/index.v8';

import GeneralInfoPageLPAbbrv1 from './Versions/LPAbbr/v1/GeneralInformation/index.v1';
import QuestionnairePageLPAbbrv1 from './Versions/LPAbbr/v1/QuestionnaireForm/index.v1';
import GeneralInfoPageLPAbbrv1_1 from './Versions/LPAbbr/v1_1/GeneralInformation/index.v1_1';
import QuestionnairePageLPAbbrv1_1 from './Versions/LPAbbr/v1_1/QuestionnaireForm/index.v1_1';
import GeneralInfoPageLPAbbrv2 from './Versions/LPAbbr/v2/GeneralInformation/index.v2';
import QuestionnairePageLPAbbrv2 from './Versions/LPAbbr/v2/QuestionnaireForm/index.v2';
import GeneralInfoPageLPAbbrv3 from './Versions/LPAbbr/v3/GeneralInformation/index.v3';
import QuestionnairePageLPAbbrv3 from './Versions/LPAbbr/v3/QuestionnaireForm/index.v3';
import GeneralInfoPageLPAbbrv4 from './Versions/LPAbbr/v4/GeneralInformation/index.v4';
import QuestionnairePageLPAbbrv4 from './Versions/LPAbbr/v4/QuestionnaireForm/index.v4';
import GeneralInfoPageLPAbbrv5 from './Versions/LPAbbr/v5/GeneralInformation/index.v5';
import QuestionnairePageLPAbbrv5 from './Versions/LPAbbr/v5/QuestionnaireForm/index.v5';
import GeneralInfoPageLPAbbrv6 from './Versions/LPAbbr/v6/GeneralInformation/index.v6';
import QuestionnairePageLPAbbrv6 from './Versions/LPAbbr/v6/QuestionnaireForm/index.v6';
import GeneralInfoPageLPAbbrv8 from './Versions/LPAbbr/v8/GeneralInformation/index.v8';
import QuestionnairePageLPAbbrv8 from './Versions/LPAbbr/v8/QuestionnaireForm/index.v8';

import GeneralInfoPageIolarv1 from './Versions/Iolar/v1/GeneralInformation/index.v1';
import QuestionnairePageIolarv1 from './Versions/Iolar/v1/QuestionnaireForm/index.v1';
import GeneralInfoPageIolarv2 from './Versions/Iolar/v2/GeneralInformation/index.v2';
import QuestionnairePageIolarv2 from './Versions/Iolar/v2/QuestionnaireForm/index.v2';
import GeneralInfoPageIolarv3 from './Versions/Iolar/v3/GeneralInformation/index.v3';
import QuestionnairePageIolarv3 from './Versions/Iolar/v3/QuestionnaireForm/index.v3';
import InstructionsPageIolar from './Versions/Iolar/Instructions/index';

import GeneralInfoPageOSAGEv1 from './Versions/OSAGE/v1/GeneralInformation/index.v1';
import QuestionnairePageOSAGEv1 from './Versions/OSAGE/v1/QuestionnaireForm/index.v1';
import GeneralInfoPageOSAGEv2 from './Versions/OSAGE/v2/GeneralInformation/index.v2';
import QuestionnairePageOSAGEv2 from './Versions/OSAGE/v2/QuestionnaireForm/index.v2';
import GeneralInfoPageOSAGEv3 from './Versions/OSAGE/v3/GeneralInformation/index.v3';
import QuestionnairePageOSAGEv3 from './Versions/OSAGE/v3/QuestionnaireForm/index.v3';

import GeneralInfoPageNewLimitedPartnerv1 from './Versions/NewLimitedPartner/v1/GeneralInformation/index.v1';
import QuestionnairePageNewLimitedPartnerv1 from './Versions/NewLimitedPartner/v1/QuestionnaireForm/index.v1';
import GeneralInfoPageNewLimitedPartnerv2 from './Versions/NewLimitedPartner/v2/GeneralInformation/index.v2';
import QuestionnairePageNewLimitedPartnerv2 from './Versions/NewLimitedPartner/v2/QuestionnaireForm/index.v2';
import GeneralInfoPageNewLimitedPartnerv3 from './Versions/NewLimitedPartner/v3/GeneralInformation/index.v3';
import QuestionnairePageNewLimitedPartnerv3 from './Versions/NewLimitedPartner/v3/QuestionnaireForm/index.v3';

import InstructionsPageTcgCrossOver from './Versions/LP/Instructions/index';
import GeneralInfoPageTcgCrossOverv1 from './Versions/TcgCrossOver/v1/GeneralInformation/index.v1';
import QuestionnairePageTcgCrossOverv1 from './Versions/TcgCrossOver/v1/QuestionnaireForm/index.v1';
import GeneralInfoPageTcgCrossOverv2 from './Versions/TcgCrossOver/v2/GeneralInformation/index.v2';
import QuestionnairePageTcgCrossOverv2 from './Versions/TcgCrossOver/v2/QuestionnaireForm/index.v2';
import GeneralInfoPageTcgCrossOverv3 from './Versions/TcgCrossOver/v3/GeneralInformation/index.v3';
import QuestionnairePageTcgCrossOverv3 from './Versions/TcgCrossOver/v3/QuestionnaireForm/index.v3';

import InstructionsPageTcgCrossOverCayman from './Versions/tcgCrossOverCayman/Instructions/index';
import GeneralInfoPageTcgCrossOverCaymanv1 from './Versions/tcgCrossOverCayman/v1/GeneralInformation/index.v1';
import QuestionnairePageTcgCrossOverCaymanv1 from './Versions/tcgCrossOverCayman/v1/QuestionnaireForm/index.v1';
import GeneralInfoPageTcgCrossOverCaymanv2 from './Versions/tcgCrossOverCayman/v2/GeneralInformation/index.v2';
import QuestionnairePageTcgCrossOverCaymanv2 from './Versions/tcgCrossOverCayman/v2/QuestionnaireForm/index.v2';
import QuestionnaireIndexPageTcgCrossOverCaymanv2 from './Versions/tcgCrossOverCayman/v2/QuestionnaireIndex/index.v2';

import InstructionsPageBitKraft from './Versions/BITKRAFT/Instructions/index';
import GeneralInfoPageBitKraftv1 from './Versions/BITKRAFT/v1/GeneralInformation/index.v1';
import QuestionnairePageBitKraftv1 from './Versions/BITKRAFT/v1/QuestionnaireForm/index.v1';
import GeneralInfoPageBitKraftv2 from './Versions/BITKRAFT/v2/GeneralInformation/index.v2';
import QuestionnairePageBitKraftv2 from './Versions/BITKRAFT/v2/QuestionnaireForm/index.v2';
import GeneralInfoPageBitKraftv3 from './Versions/BITKRAFT/v3/GeneralInformation/index.v3';
import QuestionnairePageBitKraftv3 from './Versions/BITKRAFT/v3/QuestionnaireForm/index.v3';


import InstructionsPageBitKraftIndia from './Versions/bitkraftIndia/Instructions/index';
import GeneralInfoPageBitKraftIndiav1 from './Versions/bitkraftIndia/v1/GeneralInformation/index.v1';
import QuestionnairePageBitKraftIndiav1 from './Versions/bitkraftIndia/v1/QuestionnaireForm/index.v1';

import InstructionsPageElephantPartner from './Versions/ElephantPartner/Instructions/index';
import GeneralInfoPageElephantPartnerv1 from './Versions/ElephantPartner/v1/GeneralInformation/index.v1';
import QuestionnairePageElephantPartnerv1 from './Versions/ElephantPartner/v1/QuestionnaireForm/index.v1';
import GeneralInfoPageElephantPartnerv2 from './Versions/ElephantPartner/v2/GeneralInformation/index.v2';
import QuestionnairePageElephantPartnerv2 from './Versions/ElephantPartner/v2/QuestionnaireForm/index.v2';
import GeneralInfoPageElephantPartnerv3 from './Versions/ElephantPartner/v3/GeneralInformation/index.v3';
import QuestionnairePageElephantPartnerv3 from './Versions/ElephantPartner/v3/QuestionnaireForm/index.v3';

import GeneralInfoPageFireworkv1 from './Versions/Firework/v1/GeneralInformation/index.v1';
import QuestionnairePageFireworkv1 from './Versions/Firework/v1/QuestionnaireForm/index.v1';
import GeneralInfoPageFireworkv2 from './Versions/Firework/v2/GeneralInformation/index.v2';
import QuestionnairePageFireworkv2 from './Versions/Firework/v2/QuestionnaireForm/index.v2';
import GeneralInfoPageFireworkv3 from './Versions/Firework/v3/GeneralInformation/index.v3';
import QuestionnairePageFireworkv3 from './Versions/Firework/v3/QuestionnaireForm/index.v3';

import QuestionnairePrometheanv1 from './Versions/promethean/v1/QuestionnaireForm/index.v1';
import GeneralInfoPagePrometheanv1 from './Versions/promethean/v1/GeneralInformation/index.v1';
import QuestionnairePrometheanv2 from './Versions/promethean/v2/QuestionnaireForm/index.v2';
import GeneralInfoPagePrometheanv2 from './Versions/promethean/v2/GeneralInformation/index.v2';
import QuestionnairePrometheanv3 from './Versions/promethean/v3/QuestionnaireForm/index.v3';
import GeneralInfoPagePrometheanv3 from './Versions/promethean/v3/GeneralInformation/index.v3';

import InstructionsPageAccel from './Versions/accel/Instructions/index';
import InterestLetterPageAccelv1 from './Versions/accel/v1/InvestmentInterestLetter/index.v1';
import GeneralInfoPageAccelv1 from './Versions/accel/v1/GeneralInformation/index.v1';
import QuestionnairePageAccelv1 from './Versions/accel/v1/QuestionnaireForm/index.v1';
import InterestLetterPageAccelv2 from './Versions/accel/v2/InvestmentInterestLetter/index.v2';
import GeneralInfoPageAccelv2 from './Versions/accel/v2/GeneralInformation/index.v2';
import QuestionnairePageAccelv2 from './Versions/accel/v2/QuestionnaireForm/index.v2';
import InterestLetterPageAccelv3 from './Versions/accel/v3/InvestmentInterestLetter/index.v3';
import GeneralInfoPageAccelv3 from './Versions/accel/v3/GeneralInformation/index.v3';
import QuestionnairePageAccelv3 from './Versions/accel/v3/QuestionnaireForm/index.v3';
import GeneralInfoPageAccelv4 from './Versions/accel/v4/GeneralInformation/index.v4';
import QuestionnairePageAccelv4 from './Versions/accel/v4/QuestionnaireForm/index.v4';
import InterestLetterPageAccelv4 from './Versions/accel/v4/InvestmentInterestLetter/index.v4';

import InstructionsPageSinglePictureCapital from './Versions/singlePictureCapital/Instructions/index';
import GeneralInfoPageSinglePictureCapitalv1 from './Versions/singlePictureCapital/v1/GeneralInformation/index.v1';
import QuestionnairePageSinglePictureCapitalv1 from './Versions/singlePictureCapital/v1/QuestionnaireForm/index.v1';
import GeneralInfoPageSinglePictureCapitalv2 from './Versions/singlePictureCapital/v2/GeneralInformation/index.v2';
import QuestionnairePageSinglePictureCapitalv2 from './Versions/singlePictureCapital/v2/QuestionnaireForm/index.v2';

import InstructionsPageAccelMain from './Versions/accelMain/Instructions/index';
import GeneralInfoPageAccelMainv1 from './Versions/accelMain/v1/GeneralInformation/index.v1';
import QuestionnairePageAccelMainv1 from './Versions/accelMain/v1/QuestionnaireForm/index.v1';
import GeneralInfoPageAccelMainv2 from './Versions/accelMain/v2/GeneralInformation/index.v2';
import QuestionnairePageAccelMainv2 from './Versions/accelMain/v2/QuestionnaireForm/index.v2';

import InstructionsPageAccelEntrepreneurs from './Versions/accelEntrepreneurs/Instructions/index';
import GeneralInfoPageAccelEntrepreneursv1 from './Versions/accelEntrepreneurs/v1/GeneralInformation/index.v1';
import QuestionnairePageAccelEntrepreneursv1 from './Versions/accelEntrepreneurs/v1/QuestionnaireForm/index.v1';
import GeneralInfoPageAccelEntrepreneursv2 from './Versions/accelEntrepreneurs/v2/GeneralInformation/index.v2';
import QuestionnairePageAccelEntrepreneursv2 from './Versions/accelEntrepreneurs/v2/QuestionnaireForm/index.v2';

import InstructionsPageAccelCirclev1 from './Versions/accelCircle/v1/Instructions/index.v1';
import GeneralInfoPageAccelCirclev1 from './Versions/accelCircle/v1/GeneralInformation/index.v1';
import QuestionnairePageAccelCirclev1 from './Versions/accelCircle/v1/QuestionnaireForm/index.v1';
import InstructionsPageAccelCirclev2 from './Versions/accelCircle/v2/Instructions/index.v2';
import GeneralInfoPageAccelCirclev2 from './Versions/accelCircle/v2/GeneralInformation/index.v2';
import QuestionnairePageAccelCirclev2 from './Versions/accelCircle/v2/QuestionnaireForm/index.v2';
import QuestionnaireIndexPageAccelCirclev2 from './Versions/accelCircle/v2/QuestionnaireIndex/index.v2';

import GeneralInfoPageAccelEtpnReturningv1 from './Versions/accelEtpnReturning/v1/GeneralInformation/index.v1';
import GeneralInfoPageAccelEtpnReturningv2 from './Versions/accelEtpnReturning/v2/GeneralInformation/index.v2';

import GeneralInfoPageAccelEtpnReturningMultiFundv1 from './Versions/accelEtpnReturningMultiFund/v1/GeneralInformation/index.v1';

import InstructionsPageAudere from './Versions/Audere/Instructions/index';
import GeneralInfoPageAuderev1 from './Versions/Audere/v1/GeneralInformation/index.v1';
import QuestionnairePageAuderev1 from './Versions/Audere/v1/QuestionnaireForm/index.v1';
import GeneralInfoPageAuderev2 from './Versions/Audere/v2/GeneralInformation/index.v2';
import QuestionnairePageAuderev2 from './Versions/Audere/v2/QuestionnaireForm/index.v2';
import GeneralInfoPageAuderev3 from './Versions/Audere/v3/GeneralInformation/index.v3';
import QuestionnairePageAuderev3 from './Versions/Audere/v3/QuestionnaireForm/index.v3';

import InstructionsPageCayman from './Versions/cayman/Instructions/index';
import GeneralInfoPageCaymanv1 from './Versions/cayman/v1/GeneralInformation/index.v1';
import QuestionnairePageCaymanv1 from './Versions/cayman/v1/QuestionnaireForm/index.v1';
import GeneralInfoPageCaymanv2 from './Versions/cayman/v2/GeneralInformation/index.v2';
import QuestionnairePageCaymanv2 from './Versions/cayman/v2/QuestionnaireForm/index.v2';
import InstructionsPageCaymanv3 from './Versions/cayman/v3/Instructions/index.v3';
import GeneralInfoPageCaymanv3 from './Versions/cayman/v3/GeneralInformation/index.v3';
import QuestionnairePageCaymanv3 from './Versions/cayman/v3/QuestionnaireForm/index.v3';
import InstructionsPageCaymanv4 from './Versions/cayman/v4/Instructions/index.v4';
import GeneralInfoPageCaymanv4 from './Versions/cayman/v4/GeneralInformation/index.v4';
import QuestionnairePageCaymanv4 from './Versions/cayman/v4/QuestionnaireForm/index.v4';

import InstructionsPageCaymanv6 from './Versions/cayman/v6/Instructions/index.v6';
import GeneralInfoPageCaymanv6 from './Versions/cayman/v6/GeneralInformation/index.v6';
import QuestionnairePageCaymanv6 from './Versions/cayman/v6/QuestionnaireForm/index.v6';
import InstructionsPageCaymanv7 from './Versions/cayman/v7/Instructions/index.v7';
import GeneralInfoPageCaymanv7 from './Versions/cayman/v7/GeneralInformation/index.v7';
import QuestionnairePageCaymanv7 from './Versions/cayman/v7/QuestionnaireForm/index.v7';
import QuestionnaireIndexPageCaymanv7 from './Versions/cayman/v7/QuestionnaireIndex/index.v7';

import InstructionsLPMultiFund from './Versions/LPMultiFund/Instructions';
import GeneralInfoPageLPMultiFundv1 from './Versions/LPMultiFund/v1/GeneralInformation/index.v1';
import QuestionnairePageLPMultiFundv1 from './Versions/LPMultiFund/v1/QuestionnaireForm/index.v1';
import GeneralInfoPageLPMultiFundv2 from './Versions/LPMultiFund/v2/GeneralInformation/index.v2';
import QuestionnairePageLPMultiFundv2 from './Versions/LPMultiFund/v2/QuestionnaireForm/index.v2';
import InstructionsLPMultiFundv2 from './Versions/LPMultiFund/v2/Instructions';
import GeneralInfoPageLPMultiFundv3 from './Versions/LPMultiFund/v3/GeneralInformation/index.v3';
import QuestionnairePageLPMultiFundv3 from './Versions/LPMultiFund/v3/QuestionnaireForm/index.v3';
import InstructionsLPMultiFundv3 from './Versions/LPMultiFund/v3/Instructions';
import GeneralInfoPageLPMultiFundv4 from './Versions/LPMultiFund/v4/GeneralInformation/index.v4';
import QuestionnairePageLPMultiFundv4 from './Versions/LPMultiFund/v4/QuestionnaireForm/index.v4';
import InstructionsLPMultiFundv4 from './Versions/LPMultiFund/v4/Instructions';
import GeneralInfoPageLPMultiFundv5 from './Versions/LPMultiFund/v5/GeneralInformation/index.v5';
import QuestionnairePageLPMultiFundv5 from './Versions/LPMultiFund/v5/QuestionnaireForm/index.v5';
import InstructionsLPMultiFundv5 from './Versions/LPMultiFund/v5/Instructions';
import InstructionsLPMultiFundv7 from './Versions/LPMultiFund/v7/Instructions/index';
import GeneralInfoPageLPMultiFundv7 from './Versions/LPMultiFund/v7/GeneralInformation/index.v7';
import QuestionnairePageLPMultiFundv7 from './Versions/LPMultiFund/v7/QuestionnaireForm/index.v7';

import GeneralInfoPageLimitedPartnershipMFv1 from './Versions/limitedPartnershipMF/v1/GeneralInformation/index.v1';
import QuestionnairePageLimitedPartnershipMFv1 from './Versions/limitedPartnershipMF/v1/QuestionnaireForm/index.v1';
import GeneralInfoPageLimitedPartnershipMFv2 from './Versions/limitedPartnershipMF/v2/GeneralInformation/index.v2';
import QuestionnairePageLimitedPartnershipMFv2 from './Versions/limitedPartnershipMF/v2/QuestionnaireForm/index.v2';
import GeneralInfoPageLimitedPartnershipMFv3 from './Versions/limitedPartnershipMF/v3/GeneralInformation/index.v3';
import QuestionnairePageLimitedPartnershipMFv3 from './Versions/limitedPartnershipMF/v3/QuestionnaireForm/index.v3';
import GeneralInfoPageLimitedPartnershipMFv4 from './Versions/limitedPartnershipMF/v4/GeneralInformation/index.v4';
import QuestionnairePageLimitedPartnershipMFv4 from './Versions/limitedPartnershipMF/v4/QuestionnaireForm/index.v4';
import GeneralInfoPageLimitedPartnershipMFv5 from './Versions/limitedPartnershipMF/v5/GeneralInformation/index.v5';
import QuestionnairePageLimitedPartnershipMFv5 from './Versions/limitedPartnershipMF/v5/QuestionnaireForm/index.v5';
import GeneralInfoPageLimitedPartnershipMFv7 from './Versions/limitedPartnershipMF/v7/GeneralInformation/index.v7';
import QuestionnairePageLimitedPartnershipMFv7 from './Versions/limitedPartnershipMF/v7/QuestionnaireForm/index.v7';
import InstructionsLimitedPartnershipMF from './Versions/limitedPartnershipMF/Instructions';

import GeneralInfoPageBenchmarkMultiFundv1 from './Versions/benchmarkMultiFund/v1/GeneralInformation/index.v1';
import QuestionnairePageBenchmarkMultiFundv1 from './Versions/benchmarkMultiFund/v1/QuestionnaireForm/index.v1';
import GeneralInfoPageBenchmarkMultiFundv2 from './Versions/benchmarkMultiFund/v2/GeneralInformation/index.v2';
import QuestionnairePageBenchmarkMultiFundv2 from './Versions/benchmarkMultiFund/v2/QuestionnaireForm/index.v2';
import GeneralInfoPageBenchmarkMultiFundv3 from './Versions/benchmarkMultiFund/v3/GeneralInformation/index.v3';
import QuestionnairePageBenchmarkMultiFundv3 from './Versions/benchmarkMultiFund/v3/QuestionnaireForm/index.v3';
import InstructionsBenchmarkMultiFund from './Versions/benchmarkMultiFund/Instructions';

import GeneralInfoPagePictureCapitalv1 from './Versions/pictureCapital/v1/GeneralInformation/index.v1';
import QuestionnairePagePictureCapitalv1 from './Versions/pictureCapital/v1/QuestionnaireForm/index.v1';
import GeneralInfoPagePictureCapitalv3 from './Versions/pictureCapital/v3/GeneralInformation/index.v3';
import QuestionnairePagePictureCapitalv3 from './Versions/pictureCapital/v3/QuestionnaireForm/index.v3';
import InstructionsPictureCapital from './Versions/pictureCapital/Instructions';

import GeneralInfoPageAltimeterv1 from './Versions/altimeter/v1/GeneralInformation/index.v1';
import QuestionnairePageAltimeterv1 from './Versions/altimeter/v1/QuestionnaireForm/index.v1';
import InstructionsAltimeter from './Versions/altimeter/Instructions';
import GeneralInfoPageAltimeterv2 from './Versions/altimeter/v2/GeneralInformation/index.v2';
import QuestionnairePageAltimeterv2 from './Versions/altimeter/v2/QuestionnaireForm/index.v2';

import GeneralInfoPageAltimeterPremierGrowthv1 from './Versions/altimeterPremierGrowth/v1/GeneralInformation/index.v1';
import QuestionnairePageAltimeterPremierGrowthv1 from './Versions/altimeterPremierGrowth/v1/QuestionnaireForm/index.v1';
import InstructionsAltimeterPremierGrowth from './Versions/altimeterPremierGrowth/Instructions';

import GeneralInfoPageAltimeterAMLv1 from './Versions/altimeterAML/v1/GeneralInformation/index.v1';
import QuestionnairePageAltimeterAMLv1 from './Versions/altimeterAML/v1/QuestionnaireForm/index.v1';
import InstructionsAltimeterAML from './Versions/altimeterAML/Instructions';

import GeneralInfoPageBenchmarkv1 from './Versions/benchmark/v1/GeneralInformation/index.v1';
import QuestionnairePageBenchmarkv1 from './Versions/benchmark/v1/QuestionnaireForm/index.v1';
import InstructionsPageBenchmark from './Versions/benchmark/Instructions';
import GeneralInfoPageBenchmarkv2 from './Versions/benchmark/v2/GeneralInformation/index.v2';
import QuestionnairePageBenchmarkv2 from './Versions/benchmark/v2/QuestionnaireForm/index.v2';
import QuestionnaireIndexPageBenchmarkv2 from './Versions/benchmark/v2/QuestionnaireIndex/index.v2';
import GeneralInfoPageBenchmarkv3 from './Versions/benchmark/v3/GeneralInformation/index.v3';
import QuestionnairePageBenchmarkv3 from './Versions/benchmark/v3/QuestionnaireForm/index.v3';

import GeneralInfoPageSROnev1 from './Versions/SROne/v1/GeneralInformation/index.v1';
import QuestionnairePageSROnev1 from './Versions/SROne/v1/QuestionnaireForm/index.v1';
import GeneralInfoPageSROnev2 from './Versions/SROne/v2/GeneralInformation/index.v2';
import QuestionnairePageSROnev2 from './Versions/SROne/v2/QuestionnaireForm/index.v2';
import InstructionsSROne from './Versions/SROne/Instructions';

import InstructionsPageTerrarium from './Versions/terrarium/Instructions/index';
import GeneralInfoPageTerrariumv1 from './Versions/terrarium/v1/GeneralInformation/index.v1';
import QuestionnairePageTerrariumv1 from './Versions/terrarium/v1/QuestionnaireForm/index.v1';

import InstructionsPageDCVC from './Versions/DCVC/Instructions';
import GeneralInfoPageDCVCv1 from './Versions/DCVC/v1/GeneralInformation/index.v1';
import QuestionnairePageDCVCv1 from './Versions/DCVC/v1/QuestionnaireForm/index.v1';
import GeneralInfoPageDCVCv3 from './Versions/DCVC/v3/GeneralInformation/index.v3';
import QuestionnairePageDCVCv3 from './Versions/DCVC/v3/QuestionnaireForm/index.v3';
import GeneralInfoPageDCVCv4 from './Versions/DCVC/v4/GeneralInformation/index.v4';
import QuestionnairePageDCVCv4 from './Versions/DCVC/v4/QuestionnaireForm/index.v4';

import GeneralInfoPageNICFundv1 from './Versions/NICFund/v1/GeneralInformation/index.v1';
import QuestionnairePageNICFundv1 from './Versions/NICFund/v1/QuestionnaireForm/index.v1';
import InstructionsNICFund from './Versions/NICFund/Instructions';
import GeneralInfoPageNICFundv3 from './Versions/NICFund/v3/GeneralInformation/index.v3';
import QuestionnairePageNICFundv3 from './Versions/NICFund/v3/QuestionnaireForm/index.v3';

import SignaturesPage from './Signatures';
import NotFoundPage from './../NotFound';
import {
  IQ_SET_CURRENT_STEP,
  IQ_SET_INVESTOR_FUND,
  IQ_SET_FUND,
  IQ_SET_INVESTOR,
  IQ_SHOW_EXPIRATION_NOTICE,
  IQ_SET_TRIGGER_GENERAL_INFORMATION,
  IQ_IS_SIGNATURES_ENABLED,
  IQ_SET_VALIDATION_REQUIRED_PARTS,
  IQ_SHOW_SIGNATURE_INSTRUCTIONS,
  IQ_SET_CURRENT_VERSION,
  IQ_SET_CURRENT_VERSION_QUESTIONS,
  IQ_IS_NATURAL_PERSON,
  IQ_SET_MULTI_SELECT_FORM_METADATA,
} from './reducer';
import {
  API_URL,
  SERVICE_CONFIG_QUESTIONNAIRE
} from '../../utils/service-commons';
import IqID from '../../utils/constants/questionnaire/identifiers.import';

import { questions as questionsLPv1 } from '../../utils/constants/questionnaire/limitedPartner/v1/iq-questions.lp.v1';
import { questions as questionsLPv2 } from '../../utils/constants/questionnaire/limitedPartner/v2/iq-questions.lp.v2';
import { questions as questionsLPv3 } from '../../utils/constants/questionnaire/limitedPartner/v3/iq-questions.lp.v3';
import { questions as questionsLPv4 } from '../../utils/constants/questionnaire/limitedPartner/v4/iq-questions.lp.v4';
import { questions as questionsLPv5 } from '../../utils/constants/questionnaire/limitedPartner/v5/iq-questions.lp.v5';
import { questions as questionsLPv6 } from '../../utils/constants/questionnaire/limitedPartner/v6/iq-questions.lp.v6';
import { questions as questionsLPv7 } from '../../utils/constants/questionnaire/limitedPartner/v7/iq-questions.lp.v7';
import { questions as questionsLPv8 } from '../../utils/constants/questionnaire/limitedPartner/v8/iq-questions.lp.v8';
import { questions as questionsLPv8_1 } from '../../utils/constants/questionnaire/limitedPartner/v8_1/iq-questions.lp.v8_1';
import { questions as questionsLPv9 } from '../../utils/constants/questionnaire/limitedPartner/v9/iq-questions.lp.v9';
import { questions as questionsLPv10 } from '../../utils/constants/questionnaire/limitedPartner/v10/iq-questions.lp.v10';
import { questions as questionsLPv10_1 } from '../../utils/constants/questionnaire/limitedPartner/v10_1/iq-questions.lp.v10_1';
import { questions as questionsLPv11 } from '../../utils/constants/questionnaire/limitedPartner/v11/iq-questions.lp.v11';
import { questions as questionsLPv12 } from '../../utils/constants/questionnaire/limitedPartner/v12/iq-questions.lp.v12';
import { questions as questionsLPv13 } from '../../utils/constants/questionnaire/limitedPartner/v13/iq-questions.lp.v13';
import { questions as questionsLPv14 } from '../../utils/constants/questionnaire/limitedPartner/v14/iq-questions.lp.v14';
import { questions as questionsLPv15 } from '../../utils/constants/questionnaire/limitedPartner/v15/iq-questions.lp.v15';
import { questions as questionsLPv14Seifdune } from '../../utils/constants/questionnaire/limitedPartner/v14_seifdune/iq-questions.lp.v14_seifdune';
import { questions as questionsLPv14Nosara } from '../../utils/constants/questionnaire/limitedPartner/v14_nosara/iq-questions.lp.v14_nosara';
import { questions as questionsLPv14Drumbeat } from '../../utils/constants/questionnaire/limitedPartner/v14_drumbeat/iq-questions.lp.v14_drumbeat';

import { questions as questionsVariantv1 } from '../../utils/constants/questionnaire/variant/v1/iq-questions.lp.v1';
import { questions as questionsVariantv2 } from '../../utils/constants/questionnaire/variant/v2/iq-questions.lp.v2';
import { questions as questionsVariantv3 } from '../../utils/constants/questionnaire/variant/v3/iq-questions.lp.v3';

import { questions as questionsunionPeakv1 } from '../../utils/constants/questionnaire/unionPeak/v1/iq-questions.lp.v1';
import { questions as questionsunionPeakv2 } from '../../utils/constants/questionnaire/unionPeak/v2/iq-questions.lp.v2';
import { questions as questionsunionPeakv3 } from '../../utils/constants/questionnaire/unionPeak/v3/iq-questions.lp.v3';

import { questions as questionsOCMv1 } from '../../utils/constants/questionnaire/OCM/v1/iq-questions.lp.v1';
import { questions as questionsOCMv2 } from '../../utils/constants/questionnaire/OCM/v2/iq-questions.lp.v2';

import { questions as questionsFrazierv1 } from '../../utils/constants/questionnaire/frazier/v1/iq-questions.v1';
import { questions as questionsFrazierv2 } from '../../utils/constants/questionnaire/frazier/v2/iq-questions.v2';
import { questions as questionsFrazierv3 } from '../../utils/constants/questionnaire/frazier/v3/iq-questions.v3';

import { questions as questionsLLCv1 } from '../../utils/constants/questionnaire/limitedliabilitycompany/v1/iq-questions.llc.v1';
import { questions as questionsLLCv2 } from '../../utils/constants/questionnaire/limitedliabilitycompany/v2/iq-questions.llc.v2';
import { questions as questionsLLCv3 } from '../../utils/constants/questionnaire/limitedliabilitycompany/v3/iq-questions.llc.v3';
import { questions as questionsLLCv4 } from '../../utils/constants/questionnaire/limitedliabilitycompany/v4/iq-questions.llc.v4';
import { questions as questionsLLCv5 } from '../../utils/constants/questionnaire/limitedliabilitycompany/v5/iq-questions.llc.v5';
import { questions as questionsLLCv6 } from '../../utils/constants/questionnaire/limitedliabilitycompany/v6/iq-questions.llc.v6';
import { questions as questionsLLCv6_1 } from '../../utils/constants/questionnaire/limitedliabilitycompany/v6_1/iq-questions.llc.v6_1';
import { questions as questionsLLCv7 } from '../../utils/constants/questionnaire/limitedliabilitycompany/v7/iq-questions.llc.v7';
import { questions as questionsLLCv8 } from '../../utils/constants/questionnaire/limitedliabilitycompany/v8/iq-questions.llc.v8';
import { questions as questionsLLCv8_1 } from '../../utils/constants/questionnaire/limitedliabilitycompany/v8_1/iq-questions.llc.v8_1';
import { questions as questionsLLCv9 } from '../../utils/constants/questionnaire/limitedliabilitycompany/v9/iq-questions.llc.v9';
import { questions as questionsLLCv10 } from '../../utils/constants/questionnaire/limitedliabilitycompany/v10/iq-questions.llc.v10';
import { questions as questionsLLCv11 } from '../../utils/constants/questionnaire/limitedliabilitycompany/v11/iq-questions.llc.v11';
import { questions as questionsLLCv12 } from '../../utils/constants/questionnaire/limitedliabilitycompany/v12/iq-questions.llc.v12';
import { questions as questionsLLCv13 } from '../../utils/constants/questionnaire/limitedliabilitycompany/v13/iq-questions.llc.v13';
import { questions as questionsLLCv11_ecp } from '../../utils/constants/questionnaire/limitedliabilitycompany/v11_ecp/iq-questions.llc.v11_ecp';

import { questions as questionsForesitev1 } from '../../utils/constants/questionnaire/foresite/v1/iq-questions.foresite.v1';
import { questions as questionsForesitev2 } from '../../utils/constants/questionnaire/foresite/v2/iq-questions.foresite.v2';
import { questions as questionsForesitev3 } from '../../utils/constants/questionnaire/foresite/v3/iq-questions.foresite.v3';
import { questions as questionsForesitev4 } from '../../utils/constants/questionnaire/foresite/v4/iq-questions.foresite.v4';
import { questions as questionsForesitev5 } from '../../utils/constants/questionnaire/foresite/v5/iq-questions.foresite.v5';
import { questions as questionsForesitev6 } from '../../utils/constants/questionnaire/foresite/v6/iq-questions.foresite.v6';
import { questions as questionsForesitev7 } from '../../utils/constants/questionnaire/foresite/v7/iq-questions.foresite.v7';
import { questions as questionsForesitev8 } from '../../utils/constants/questionnaire/foresite/v8/iq-questions.foresite.v8';
import { questions as questionsForesitev9 } from '../../utils/constants/questionnaire/foresite/v9/iq-questions.foresite.v9';

import { questions as questionsInitializedv1 } from '../../utils/constants/questionnaire/initialized/v1/iq-questions.initialized.v1';
import { questions as questionsInitializedv2 } from '../../utils/constants/questionnaire/initialized/v2/iq-questions.initialized.v2';
import { questions as questionsInitializedv3 } from '../../utils/constants/questionnaire/initialized/v3/iq-questions.initialized.v3';
import { questions as questionsInitializedv4 } from '../../utils/constants/questionnaire/initialized/v4/iq-questions.initialized.v4';
import { questions as questionsInitializedv5 } from '../../utils/constants/questionnaire/initialized/v5/iq-questions.initialized.v5';
import { questions as questionsInitializedv6 } from '../../utils/constants/questionnaire/initialized/v6/iq-questions.initialized.v6';
import { questions as questionsInitializedv7 } from '../../utils/constants/questionnaire/initialized/v7/iq-questions.initialized.v7';
import { questions as questionsInitializedv8 } from '../../utils/constants/questionnaire/initialized/v8/iq-questions.initialized.v8';
import { questions as questionsInitializedv9 } from '../../utils/constants/questionnaire/initialized/v9/iq-questions.initialized.v9';

import { questions as questionsQuestaCapitalv1 } from '../../utils/constants/questionnaire/questaCapital/v1/iq-questions.questaCapital.v1';
import { questions as questionsQuestaCapitalv2 } from '../../utils/constants/questionnaire/questaCapital/v2/iq-questions.questaCapital.v2';
import { questions as questionsQuestaCapitalv3 } from '../../utils/constants/questionnaire/questaCapital/v3/iq-questions.questaCapital.v3';
import { questions as questionsQuestaCapitalv4 } from '../../utils/constants/questionnaire/questaCapital/v4/iq-questions.questaCapital.v4';
import { questions as questionsQuestaCapitalv5 } from '../../utils/constants/questionnaire/questaCapital/v5/iq-questions.questaCapital.v5';
import { questions as questionsQuestaCapitalv6 } from '../../utils/constants/questionnaire/questaCapital/v6/iq-questions.questaCapital.v6';
import { questions as questionsQuestaCapitalv7 } from '../../utils/constants/questionnaire/questaCapital/v7/iq-questions.questaCapital.v7';
import { questions as questionsQuestaCapitalv8 } from '../../utils/constants/questionnaire/questaCapital/v8/iq-questions.questaCapital.v8';
import { questions as questionsQuestaCapitalv9 } from '../../utils/constants/questionnaire/questaCapital/v9/iq-questions.questaCapital.v9';

import { questions as questionsHCMv1 } from '../../utils/constants/questionnaire/hcm/v1/iq-questions.hcm.v1';
import { questions as questionsHCMv2 } from '../../utils/constants/questionnaire/hcm/v2/iq-questions.hcm.v2';
import { questions as questionsHCMv3 } from '../../utils/constants/questionnaire/hcm/v3/iq-questions.hcm.v3';
import { questions as questionsHCMv4 } from '../../utils/constants/questionnaire/hcm/v4/iq-questions.hcm.v4';
import { questions as questionsHCMv5 } from '../../utils/constants/questionnaire/hcm/v5/iq-questions.hcm.v5';
import { questions as questionsHCMv6 } from '../../utils/constants/questionnaire/hcm/v6/iq-questions.hcm.v6';

import { questions as questionsForesiteLabsv1 } from '../../utils/constants/questionnaire/foresiteLabs/v1/iq-questions.foresiteLabs.v1';
import { questions as questionsForesiteLabsv2 } from '../../utils/constants/questionnaire/foresiteLabs/v2/iq-questions.foresiteLabs.v2';
import { questions as questionsForesiteLabsv3 } from '../../utils/constants/questionnaire/foresiteLabs/v3/iq-questions.foresiteLabs.v3';
import { questions as questionsForesiteLabsv4 } from '../../utils/constants/questionnaire/foresiteLabs/v4/iq-questions.foresiteLabs.v4';
import { questions as questionsForesiteLabsv5 } from '../../utils/constants/questionnaire/foresiteLabs/v5/iq-questions.foresiteLabs.v5';
import { questions as questionsForesiteLabsv6 } from '../../utils/constants/questionnaire/foresiteLabs/v6/iq-questions.foresiteLabs.v6';
import { questions as questionsForesiteLabsv7 } from '../../utils/constants/questionnaire/foresiteLabs/v7/iq-questions.foresiteLabs.v7';
import { questions as questionsForesiteLabsv8 } from '../../utils/constants/questionnaire/foresiteLabs/v8/iq-questions.foresiteLabs.v8';

import { questions as questionsAuderev1 } from '../../utils/constants/questionnaire/Audere/v1/iq-questions.v1';
import { questions as questionsAuderev2 } from '../../utils/constants/questionnaire/Audere/v2/iq-questions.v2';
import { questions as questionsAuderev3 } from '../../utils/constants/questionnaire/Audere/v3/iq-questions.v3';
import { questions as questionsAuderev4 } from '../../utils/constants/questionnaire/Audere/v4/iq-questions.v4';

import { questions as questionsLPAbbrv1 } from '../../utils/constants/questionnaire/lpabbr/v1/iq-questions.lpabbr.v1';
import { questions as questionsLPAbbrv1_1 } from '../../utils/constants/questionnaire/lpabbr/v1_1/iq-questions.lpabbr.v1_1';
import { questions as questionsLPAbbrv2 } from '../../utils/constants/questionnaire/lpabbr/v2/iq-questions.lpabbr.v2';
import { questions as questionsLPAbbrv3 } from '../../utils/constants/questionnaire/lpabbr/v3/iq-questions.lpabbr.v3';
import { questions as questionsLPAbbrv3_1 } from '../../utils/constants/questionnaire/lpabbr/v3_1/iq-questions.lpabbr.v3_1';
import { questions as questionsLPAbbrv4 } from '../../utils/constants/questionnaire/lpabbr/v4/iq-questions.lpabbr.v4';
import { questions as questionsLPAbbrv5 } from '../../utils/constants/questionnaire/lpabbr/v5/iq-questions.lpabbr.v5';
import { questions as questionsLPAbbrv6 } from '../../utils/constants/questionnaire/lpabbr/v6/iq-questions.lpabbr.v6';
import { questions as questionsLPAbbrv7 } from '../../utils/constants/questionnaire/lpabbr/v7/iq-questions.lpabbr.v7';
import { questions as questionsLPAbbrv8 } from '../../utils/constants/questionnaire/lpabbr/v8/iq-questions.lpabbr.v8';

import { questions as questionsIolarv1 } from '../../utils/constants/questionnaire/Iolar/v1/iq-questions.iolar.v1';
import { questions as questionsIolarv2 } from '../../utils/constants/questionnaire/Iolar/v2/iq-questions.iolar.v2';
import { questions as questionsIolarv3 } from '../../utils/constants/questionnaire/Iolar/v3/iq-questions.iolar.v3';
import { questions as questionsIolarv4 } from '../../utils/constants/questionnaire/Iolar/v4/iq-questions.iolar.v4';

import { questions as questionsOSAGEv1 } from '../../utils/constants/questionnaire/osage/v1/iq-questions.osage.v1';
import { questions as questionsOSAGEv2 } from '../../utils/constants/questionnaire/osage/v2/iq-questions.osage.v2';
import { questions as questionsOSAGEv3 } from '../../utils/constants/questionnaire/osage/v3/iq-questions.osage.v3';
import { questions as questionsOSAGEv4 } from '../../utils/constants/questionnaire/osage/v4/iq-questions.osage.v4';

import { questions as questionsNewLimitedPartnerv1 } from '../../utils/constants/questionnaire/newLimitedPartner/v1/iq-questions.newLp.v1';
import { questions as questionsNewLimitedPartnerv2 } from '../../utils/constants/questionnaire/newLimitedPartner/v2/iq-questions.newLp.v2';
import { questions as questionsNewLimitedPartnerv3 } from '../../utils/constants/questionnaire/newLimitedPartner/v3/iq-questions.newLp.v3';
import { questions as questionsNewLimitedPartnerv4 } from '../../utils/constants/questionnaire/newLimitedPartner/v4/iq-questions.newLp.v4';

import { questions as questionsTcgCrossOverv1 } from '../../utils/constants/questionnaire/tcgCrossOver/v1/iq-questions.v1';
import { questions as questionsTcgCrossOverv2 } from '../../utils/constants/questionnaire/tcgCrossOver/v2/iq-questions.v2';
import { questions as questionsTcgCrossOverv3 } from '../../utils/constants/questionnaire/tcgCrossOver/v3/iq-questions.v3';
import { questions as questionsTcgCrossOverv4 } from '../../utils/constants/questionnaire/tcgCrossOver/v4/iq-questions.v4';

import { questions as questionsTcgCrossOverCaymanv1 } from '../../utils/constants/questionnaire/tcgCrossOverCayman/v1/iq-questions.v1';
import { questions as questionsTcgCrossOverCaymanv2 } from '../../utils/constants/questionnaire/tcgCrossOverCayman/v2/iq-questions.v2';

import { questions as questionsBitKraftv1 } from '../../utils/constants/questionnaire/BITKRAFT/v1/iq-questions.v1';
import { questions as questionsBitKraftv2 } from '../../utils/constants/questionnaire/BITKRAFT/v2/iq-questions.v2';
import { questions as questionsBitKraftv3 } from '../../utils/constants/questionnaire/BITKRAFT/v3/iq-questions.v3';
import { questions as questionsBitKraftv4 } from '../../utils/constants/questionnaire/BITKRAFT/v4/iq-questions.v4';

import { questions as questionsBitKraftIndiav1 } from '../../utils/constants/questionnaire/bitkraftIndia/v1/iq-questions.v1';
import { questions as questionsBitKraftIndiav2 } from '../../utils/constants/questionnaire/bitkraftIndia/v2/iq-questions.v2';

import { questions as questionsElephantPartnerv1 } from '../../utils/constants/questionnaire/ElephantPartner/v1/iq-questions.v1';
import { questions as questionsElephantPartnerv2 } from '../../utils/constants/questionnaire/ElephantPartner/v2/iq-questions.v2';
import { questions as questionsElephantPartnerv3 } from '../../utils/constants/questionnaire/ElephantPartner/v3/iq-questions.v3';
import { questions as questionsElephantPartnerv4 } from '../../utils/constants/questionnaire/ElephantPartner/v4/iq-questions.v4';

import { questions as questionsFLPv1 } from '../../utils/constants/questionnaire/firework/v1/iq-questions.lp.v1';
import { questions as questionsFLPv2 } from '../../utils/constants/questionnaire/firework/v2/iq-questions.lp.v2';
import { questions as questionsFLPv3 } from '../../utils/constants/questionnaire/firework/v3/iq-questions.lp.v3';
import { questions as questionsFLPv4 } from '../../utils/constants/questionnaire/firework/v4/iq-questions.lp.v4';

import { questions as questionsPrometheanv1 } from '../../utils/constants/questionnaire/promethean/v1/iq-questions.promethean.v1';
import { questions as questionsPrometheanv2 } from '../../utils/constants/questionnaire/promethean/v2/iq-questions.promethean.v2';
import { questions as questionsPrometheanv3 } from '../../utils/constants/questionnaire/promethean/v3/iq-questions.promethean.v3';
import { questions as questionsPrometheanv4 } from '../../utils/constants/questionnaire/promethean/v4/iq-questions.promethean.v4';

import { questions as questionsAccelv1 } from '../../utils/constants/questionnaire/accel/v1/iq-questions.accel.v1';
import { questions as questionsAccelv2 } from '../../utils/constants/questionnaire/accel/v2/iq-questions.accel.v2';
import { questions as questionsAccelv3 } from '../../utils/constants/questionnaire/accel/v3/iq-questions.accel.v3';
import { questions as questionsAccelv4 } from '../../utils/constants/questionnaire/accel/v4/iq-questions.accel.v4';

import { questions as questionsAccelMainv1 } from '../../utils/constants/questionnaire/accelMain/v1/iq-questions.accel-main.v1';
import { questions as questionsAccelMainv2 } from '../../utils/constants/questionnaire/accelMain/v2/iq-questions.accel-main.v2';
import { questions as questionsAccelMainv3 } from '../../utils/constants/questionnaire/accelMain/v3/iq-questions.accel-main.v3';

import { questions as questionsAccelEntrepreneursv1 } from '../../utils/constants/questionnaire/accelEntrepreneurs/v1/iq-questions.accel-entrepreneurs.v1';
import { questions as questionsAccelEntrepreneursv2 } from '../../utils/constants/questionnaire/accelEntrepreneurs/v2/iq-questions.accel-entrepreneurs.v2';

import { questions as questionsAccelCirclev1 } from '../../utils/constants/questionnaire/accelCircle/v1/iq-questions.accel-circle.v1';
import { questions as questionsAccelCirclev2 } from '../../utils/constants/questionnaire/accelCircle/v2/iq-questions.accel-circle.v2';

import { questions as questionsAccelEtpnReturningv1 } from '../../utils/constants/questionnaire/accelEtpnReturning/v1/iq-questions.accel-etpn-returning.v1';
import { questions as questionsAccelEtpnReturningv2 } from '../../utils/constants/questionnaire/accelEtpnReturning/v2/iq-questions.accel-etpn-returning.v2';

import { questions as questionsSinglePictureCapitalv1 } from '../../utils/constants/questionnaire/singlePictureCapital/v1/iq-questions.v1';
import { questions as questionsSinglePictureCapitalv2 } from '../../utils/constants/questionnaire/singlePictureCapital/v2/iq-questions.v2';

import { questions as questionsLPMultiFundv1 } from '../../utils/constants/questionnaire/LPMultiFund/v1/iq-questions.lpmultifund.v1';
import { questions as questionsLPMultiFundv2 } from '../../utils/constants/questionnaire/LPMultiFund/v2/iq-questions.lpmultifund.v2';
import { questions as questionsLPMultiFundv2_1 } from '../../utils/constants/questionnaire/LPMultiFund/v2_1/iq-questions.lpmultifund.v2_1';
import { questions as questionsLPMultiFundv3 } from '../../utils/constants/questionnaire/LPMultiFund/v3/iq-questions.lpmultifund.v3';
import { questions as questionsLPMultiFundv4 } from '../../utils/constants/questionnaire/LPMultiFund/v4/iq-questions.lpmultifund.v4';
import { questions as questionsLPMultiFundv5 } from '../../utils/constants/questionnaire/LPMultiFund/v5/iq-questions.lpmultifund.v5';
import { questions as questionsLPMultiFundv6 } from '../../utils/constants/questionnaire/LPMultiFund/v6/iq-questions.lpmultifund.v6';
import { questions as questionsLPMultiFundv7 } from '../../utils/constants/questionnaire/LPMultiFund/v7/iq-questions.lpmultifund.v7';

import { questions as questionsLimitedPartnershipMFv1 } from '../../utils/constants/questionnaire/limitedPartnershipMF/v1/iq-questions.lpmf.v1';
import { questions as questionsLimitedPartnershipMFv2 } from '../../utils/constants/questionnaire/limitedPartnershipMF/v2/iq-questions.lpmf.v2';
import { questions as questionsLimitedPartnershipMFv2_1 } from '../../utils/constants/questionnaire/limitedPartnershipMF/v2_1/iq-questions.lpmf.v2_1';
import { questions as questionsLimitedPartnershipMFv3 } from '../../utils/constants/questionnaire/limitedPartnershipMF/v3/iq-questions.lpmf.v3';
import { questions as questionsLimitedPartnershipMFv4 } from '../../utils/constants/questionnaire/limitedPartnershipMF/v4/iq-questions.lpmf.v4';
import { questions as questionsLimitedPartnershipMFv5 } from '../../utils/constants/questionnaire/limitedPartnershipMF/v5/iq-questions.lpmf.v5';
import { questions as questionsLimitedPartnershipMFv6 } from '../../utils/constants/questionnaire/limitedPartnershipMF/v6/iq-questions.lpmf.v6';
import { questions as questionsLimitedPartnershipMFv7 } from '../../utils/constants/questionnaire/limitedPartnershipMF/v7/iq-questions.lpmf.v7';

import { questions as questionsLimitedPartnershipMFv6_SparkCapital } from '../../utils/constants/questionnaire/limitedPartnershipMF/v6_spark_capital/iq-questions.lpmf.v6_spark_capital';

import { questions as questionsBenchmarkMultiFundv1 } from '../../utils/constants/questionnaire/benchmarkMultiFund/v1/iq-questions.v1';
import { questions as questionsBenchmarkMultiFundv2 } from '../../utils/constants/questionnaire/benchmarkMultiFund/v2/iq-questions.v2';
import { questions as questionsBenchmarkMultiFundv3 } from '../../utils/constants/questionnaire/benchmarkMultiFund/v3/iq-questions.v3';

import { questions as questionsPictureCapitalv1 } from '../../utils/constants/questionnaire/pictureCapital/v1/iq-questions.v1';
import { questions as questionsPictureCapitalv2 } from '../../utils/constants/questionnaire/pictureCapital/v2/iq-questions.v2';
import { questions as questionsPictureCapitalv3 } from '../../utils/constants/questionnaire/pictureCapital/v3/iq-questions.v3';

import { questions as questionsCaymanv1 } from '../../utils/constants/questionnaire/cayman/v1/iq-questions.v1';
import { questions as questionsCaymanv2 } from '../../utils/constants/questionnaire/cayman/v2/iq-questions.v2';
import { questions as questionsCaymanv3 } from '../../utils/constants/questionnaire/cayman/v3/iq-questions.v3';
import { questions as questionsCaymanv4 } from '../../utils/constants/questionnaire/cayman/v4/iq-questions.v4';
import { questions as questionsCaymanv5 } from '../../utils/constants/questionnaire/cayman/v5/iq-questions.v5';
import { questions as questionsCaymanv6 } from '../../utils/constants/questionnaire/cayman/v6/iq-questions.v6';
import { questions as questionsCaymanv7 } from '../../utils/constants/questionnaire/cayman/v7/iq-questions.v7';

import { questions as questionsSROnev1 } from '../../utils/constants/questionnaire/SROne/v1/iq-questions.sr-one.v1';
import { questions as questionsSROnev2 } from '../../utils/constants/questionnaire/SROne/v2/iq-questions.sr-one.v2';
import { questions as questionsSROnev3 } from '../../utils/constants/questionnaire/SROne/v3/iq-questions.sr-one.v3';

import { questions as questionsTerrariumv1 } from '../../utils/constants/questionnaire/terrarium/v1/iq-questions.lp.v1';
import { questions as questionsTerrariumv2 } from '../../utils/constants/questionnaire/terrarium/v2/iq-questions.lp.v2';

import { questions as questionsDCVCv1 } from '../../utils/constants/questionnaire/DCVC/v1/iq-questions.v1';
import { questions as questionsDCVCv2 } from '../../utils/constants/questionnaire/DCVC/v2/iq-questions.v2';
import { questions as questionsDCVCv3 } from '../../utils/constants/questionnaire/DCVC/v3/iq-questions.v3';
import { questions as questionsDCVCv4 } from '../../utils/constants/questionnaire/DCVC/v4/iq-questions.v4';

import { questions as questionsNICFundv1 } from '../../utils/constants/questionnaire/NICFund/v1/iq-questions.v1';
import { questions as questionsNICFundv2 } from '../../utils/constants/questionnaire/NICFund/v2/iq-questions.v2';
import { questions as questionsNICFundv3 } from '../../utils/constants/questionnaire/NICFund/v3/iq-questions.v3';

import { questions as questionsSorensonv1 } from '../../utils/constants/questionnaire/sorenson/v1/iq-questions.v1';
import { questions as questionsSorensonv2 } from '../../utils/constants/questionnaire/sorenson/v2/iq-questions.v2';
import { questions as questionsSorensonv3 } from '../../utils/constants/questionnaire/sorenson/v3/iq-questions.v3';

import { questions as questionsAltimeterv1 } from '../../utils/constants/questionnaire/altimeter/v1/iq-questions.v1';
import { questions as questionsAltimeterv2 } from '../../utils/constants/questionnaire/altimeter/v2/iq-questions.v2';

import { questions as questionsAltimeterPremierGrowthv1 } from '../../utils/constants/questionnaire/altimiterPremierGrowth/v1/iq-questions.v1';

import { questions as questionsAltimeterAMLv1 } from '../../utils/constants/questionnaire/altimeterAML/v1/iq-questions.v1';

import { questions as questionsBenchmarkv1 } from '../../utils/constants/questionnaire/benchmark/v1/iq-questions.v1';
import { questions as questionsBenchmarkv2 } from '../../utils/constants/questionnaire/benchmark/v2/iq-questions.v2';
import { questions as questionsBenchmarkv3 } from '../../utils/constants/questionnaire/benchmark/v3/iq-questions.v3';

import {
  yesOrNoQuestions,
  textFieldQuestions,
  multiSelectQuestions,
} from './../../utils/constants/questionnaire/disabledQuestions';

import {
  LimitedPartnerV1,
  LimitedPartnerV2,
  LimitedPartnerV3,
  LimitedPartnerV4,
  LimitedPartnerV5,
  LimitedPartnerV6,
  LimitedPartnerV7,
  LimitedPartnerV8,
  LimitedPartnerV8_1,
  LimitedPartnerV9,
  LimitedPartnerV10,
  LimitedPartnerV10_1,
  LimitedPartnerV11,
  LimitedPartnerV12,
  LimitedPartnerV13,
  LimitedPartnerV14,
  LimitedPartnerV15,
  LimitedPartnerV14_Seifdune,
  LimitedPartnerV14_Nosara,
  LimitedPartnerV14_Drumbeat,
  LimitedPartnerV14_teamworthy,
  LimitedLiabilityCompanyV1,
  LimitedLiabilityCompanyV2,
  LimitedLiabilityCompanyV3,
  LimitedLiabilityCompanyV4,
  LimitedLiabilityCompanyV5,
  LimitedLiabilityCompanyV6,
  LimitedLiabilityCompanyV6_1,
  LimitedLiabilityCompanyV7,
  LimitedLiabilityCompanyV8,
  LimitedLiabilityCompanyV8_1,
  LimitedLiabilityCompanyV9,
  LimitedLiabilityCompanyV10,
  LimitedLiabilityCompanyV11,
  LimitedLiabilityCompanyV12,
  LimitedLiabilityCompanyV13,
  LimitedLiabilityCompanyV11_ecp,
  ForesiteV1,
  ForesiteV2,
  ForesiteV3,
  ForesiteV4,
  ForesiteV5,
  ForesiteV6,
  ForesiteV7,
  ForesiteV8,
  ForesiteV9,
  QuestaCapitalV1,
  QuestaCapitalV2,
  QuestaCapitalV3,
  QuestaCapitalV4,
  QuestaCapitalV5,
  QuestaCapitalV6,
  QuestaCapitalV7,
  QuestaCapitalV8,
  QuestaCapitalV9,
  InitializedV1,
  InitializedV2,
  InitializedV3,
  InitializedV4,
  InitializedV5,
  InitializedV6,
  InitializedV7,
  InitializedV8,
  InitializedV9,
  HCMV1,
  HCMV2,
  HCMV3,
  HCMV4,
  HCMV5,
  HCMV6,
  ForesiteLabsV1,
  ForesiteLabsV2,
  ForesiteLabsV3,
  ForesiteLabsV4,
  ForesiteLabsV5,
  ForesiteLabsV6,
  ForesiteLabsV7,
  ForesiteLabsV8,
  LPABBRV1,
  LPABBRV1_1,
  LPABBRV2,
  LPABBRV3,
  LPABBRV3_1,
  LPABBRV4,
  LPABBRV5,
  LPABBRV6,
  LPABBRV7,
  LPABBRV8,
  OSAGEV1,
  OSAGEV2,
  OSAGEV3,
  OSAGEV4,
  NewLimitedPartnerV1,
  NewLimitedPartnerV2,
  NewLimitedPartnerV3,
  NewLimitedPartnerV4,
  FireworkV1,
  FireworkV2,
  FireworkV3,
  FireworkV4,
  PrometheanV1,
  PrometheanV2,
  PrometheanV3,
  PrometheanV4,
  AccelV1,
  AccelV2,
  AccelV3,
  AccelV4,
  AccelMainV1,
  AccelMainV2,
  AccelMainV3,
  AccelEntrepreneursV1,
  AccelEntrepreneursV2,
  AccelEtpnReturningV1,
  AccelEtpnReturningV2,
  AccelEtpnReturningMultiV1,
  LPMULTIFUNDV1,
  LPMULTIFUNDV2,
  LPMULTIFUNDV2_1,
  LPMULTIFUNDV3,
  LPMULTIFUNDV4,
  LPMULTIFUNDV5,
  LPMULTIFUNDV6,
  LPMULTIFUNDV7,
  TcgCrossOverV1,
  TcgCrossOverV2,
  TcgCrossOverV3,
  TcgCrossOverV4,
  TcgCrossOverCaymanV1,
  TcgCrossOverCaymanV2,
  IOLARV1,
  IOLARV2,
  IOLARV3,
  IOLARV4,
  BITKRAFTV1,
  BITKRAFTV2,
  BITKRAFTV3,
  BITKRAFTV4,
  BitkraftIndiaV1,
  BitkraftIndiaV2,
  ElephantPartnerV1,
  ElephantPartnerV2,
  ElephantPartnerV3,
  ElephantPartnerV4,
  LimitedPartnershipMFV1,
  LimitedPartnershipMFV2,
  LimitedPartnershipMFV2_1,
  LimitedPartnershipMFV3,
  LimitedPartnershipMFV4,
  LimitedPartnershipMFV5,
  LimitedPartnershipMFV6,
  LimitedPartnershipMFV6_SparkCapital,
  LimitedPartnershipMFV7,
  AudereV1,
  AudereV2,
  AudereV3,
  AudereV4,
  CaymanV1,
  CaymanV2,
  CaymanV3,
  CaymanV4,
  CaymanV5,
  CaymanV6,
  CaymanV7,
  SROneV1,
  SROneV2,
  SROneV3,
  FrazierV1,
  FrazierV2,
  FrazierV3,
  TerrariumV1,
  TerrariumV2,
  DCVCV1,
  DCVCV2,
  DCVCV3,
  DCVCV4,
  OCMV1,
  OCMV2,
  NICFUNDV1,
  NICFUNDV2,
  NICFUNDV3,
  VariantV1,
  VariantV2,
  VariantV3,
  SorensonV1,
  SorensonV2,
  SorensonV3,
  UnionPeakV1,
  UnionPeakV2,
  UnionPeakV3,
  AccelCircleV1,
  AccelCircleV2,
  PictureCapitalV1,
  PictureCapitalV2,
  PictureCapitalV3,
  AltimeterV1,
  AltimeterV2,
  AltimeterPremierGrowthV1,
  AltimeterAMLV1,
  BenchmarkV1,
  BenchmarkV2,
  BenchmarkV3,
  BenchmarkMultiFundV1,
  BenchmarkMultiFundV2,
  BenchmarkMultiFundV3,
  SinglePictureCapitalV1,
  SinglePictureCapitalV2,
} from '../../utils/constants/questionnaire/versions';
import { IQ_SET_SIGNATURES_METHOD } from './reducer';
import { confirmDocCanBeSigned, confirmReturningInvestorCanSign, confirmAltimeterAMLDocCanBeSigned } from './util';
import { handleQuestionnaireError } from '../../utils/requestErrorHandler';
import { FUND_VERSION } from '../../utils/constants/fund-versions';
import { QuestionnaireStepsVariant } from './QuestionnaireStepsVariant/index';
import { ProgressVariant } from './QuestionnaireStepsVariant/Progress/index';
import { DistributionForm } from './Versions/variant/v1/Distribution/index.v1';
import { DistributionForm as DistributionFormV3 } from './Versions/variant/v3/Distribution/index.v3';
import { ProgressUnionPeak } from './QuestionnaireStepsUnionPeak/Progress/index';
import { QuestionnaireStepsUnionPeak } from './QuestionnaireStepsUnionPeak/index';
import { DissolutionForm } from './Versions/unionPeak/v1/Disolution/index.v1';
import { DissolutionForm as DissolutionFormV3 } from './Versions/unionPeak/v3/Disolution/index.v3';

/**
 * @typedef {Object} Props
 * @property {Object} history
 * @property {Gunderson.Context} questionnaireContext
*/

export const iq_last_step_token = 'iq-last-step';
export const iq_cb_token = 'iq-cb-token';
export const iq_cb_user_token = 'iq-cb-user';
export const iq_general_info_token = 'generalInfo';

let restrictAccess = false;

/**
 * @class 
 * @extends {Component<Props>}
*/
export class QuestionnaireExperienceHome extends Component {
  static defaultProps = {
    history: {},
  };

  componentDidMount() {
    const { investorFund } = this.props.questionnaireContext;
    if (investorFund && investorFund.questionnaire) {
      this.props.setVersion(
        investorFund.questionnaire.iqVersion || LimitedPartnerV1
      );
    }

    const iqToken = sessionStorage.getItem('iq_cb_token');
    const userToken = sessionStorage.getItem('iq_cb_user_token');

    if (iqToken && userToken) {
      window.addEventListener('beforeunload', (event) => {
        event.returnValue = 'Are you sure you want to leave?';
      });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    const { questionnaireContext } = this.props;
    if (
      prevProps.questionnaireContext.currentVersion !==
        questionnaireContext.currentVersion ||
      (questionnaireContext.currentVersion !== '' &&
        !questionnaireContext.currentVersionInitialized &&
        !questionnaireContext.currentVersionQuestions.length)
    ) {
      let targetVersionQuestions = null;
      switch (questionnaireContext.currentVersion) {
        case LimitedPartnerV1:
          targetVersionQuestions = questionsLPv1;
          break;
        case LimitedPartnerV2:
          targetVersionQuestions = questionsLPv2;
          break;
        case LimitedPartnerV3:
          targetVersionQuestions = questionsLPv3;
          break;
        case LimitedPartnerV4:
          targetVersionQuestions = questionsLPv4;
          break;
        case LimitedPartnerV5:
          targetVersionQuestions = questionsLPv5;
          break;
        case LimitedPartnerV6:
          targetVersionQuestions = questionsLPv6;
          break;
        case LimitedPartnerV7:
          targetVersionQuestions = questionsLPv7;
          break;
        case LimitedPartnerV8:
          targetVersionQuestions = questionsLPv8;
          break;
        case LimitedPartnerV8_1:
          targetVersionQuestions = questionsLPv8_1;
          break;
        case LimitedPartnerV9:
          targetVersionQuestions = questionsLPv9;
          break;
        case LimitedPartnerV10:
          targetVersionQuestions = questionsLPv10;
          break;
        case LimitedPartnerV10_1:
          targetVersionQuestions = questionsLPv10_1;
          break;
        case LimitedPartnerV11:
          targetVersionQuestions = questionsLPv11;
          break;
        case LimitedPartnerV12:
          targetVersionQuestions = questionsLPv12;
          break;
        case LimitedPartnerV13:
          targetVersionQuestions = questionsLPv13;
          break;
        case LimitedPartnerV14:
        case LimitedPartnerV14_teamworthy:
          targetVersionQuestions = questionsLPv14;
          break;
        case LimitedPartnerV15:
          targetVersionQuestions = questionsLPv15;
          break;
        case LimitedPartnerV14_Seifdune:
          targetVersionQuestions = questionsLPv14Seifdune;
          break;
        case LimitedPartnerV14_Nosara:
          targetVersionQuestions = questionsLPv14Nosara;
          break;
        case LimitedPartnerV14_Drumbeat:
          targetVersionQuestions = questionsLPv14Drumbeat;
          break;

        case AltimeterV1:
          targetVersionQuestions = questionsAltimeterv1;
          break;
        case AltimeterV2:
          targetVersionQuestions = questionsAltimeterv2;
          break;
        case AltimeterPremierGrowthV1:
          targetVersionQuestions = questionsAltimeterPremierGrowthv1;
          break;
        case AltimeterAMLV1:
          targetVersionQuestions = questionsAltimeterAMLv1;
          break;

        case BenchmarkV1:
          targetVersionQuestions = questionsBenchmarkv1;
          break;
        case BenchmarkV2:
          targetVersionQuestions = questionsBenchmarkv2;
          break;
        case BenchmarkV3:
          targetVersionQuestions = questionsBenchmarkv3;
          break;

        case SinglePictureCapitalV1:
          targetVersionQuestions = questionsSinglePictureCapitalv1;
          break;
        case SinglePictureCapitalV2:
          targetVersionQuestions = questionsSinglePictureCapitalv2;
          break;

        case VariantV1:
          targetVersionQuestions = questionsVariantv1;
          break;

        case VariantV2:
          targetVersionQuestions = questionsVariantv2;
          break;
        case VariantV3:
          targetVersionQuestions = questionsVariantv3;
          break;

        case UnionPeakV1:
          targetVersionQuestions = questionsunionPeakv1;
          break;

        case UnionPeakV2:
          targetVersionQuestions = questionsunionPeakv2;
          break;
        case UnionPeakV3:
          targetVersionQuestions = questionsunionPeakv3;
          break;

        case SorensonV1:
          targetVersionQuestions = questionsSorensonv1;
          break;
        
        case SorensonV2:
          targetVersionQuestions = questionsSorensonv2;
          break;
        case SorensonV3:
          targetVersionQuestions = questionsSorensonv3;
          break;

        case OCMV1:
          targetVersionQuestions = questionsOCMv1;
          break;

        case OCMV2:
          targetVersionQuestions = questionsOCMv2;
          break;
        
        case FrazierV1:
          targetVersionQuestions = questionsFrazierv1;
          break;
        case FrazierV2:
          targetVersionQuestions = questionsFrazierv2;
          break;
        case FrazierV3:
          targetVersionQuestions = questionsFrazierv3;
          break;

        case DCVCV1:
          targetVersionQuestions = questionsDCVCv1;
          break;
        case DCVCV2:
          targetVersionQuestions = questionsDCVCv2;
          break;
        case DCVCV3:
          targetVersionQuestions = questionsDCVCv3;
          break;
        case DCVCV4:
          targetVersionQuestions = questionsDCVCv4;
          break;

        case LimitedLiabilityCompanyV1:
          targetVersionQuestions = questionsLLCv1;
          break;
        case LimitedLiabilityCompanyV2:
          targetVersionQuestions = questionsLLCv2;
          break;
        case LimitedLiabilityCompanyV3:
          targetVersionQuestions = questionsLLCv3;
          break;
        case LimitedLiabilityCompanyV4:
          targetVersionQuestions = questionsLLCv4;
          break;
        case LimitedLiabilityCompanyV5:
          targetVersionQuestions = questionsLLCv5;
          break;
        case LimitedLiabilityCompanyV6:
          targetVersionQuestions = questionsLLCv6;
          break;
        case LimitedLiabilityCompanyV6_1:
          targetVersionQuestions = questionsLLCv6_1;
          break;
        case LimitedLiabilityCompanyV7:
          targetVersionQuestions = questionsLLCv7;
          break;
        case LimitedLiabilityCompanyV8:
          targetVersionQuestions = questionsLLCv8;
          break;
        case LimitedLiabilityCompanyV8_1:
          targetVersionQuestions = questionsLLCv8_1;
          break;
        case LimitedLiabilityCompanyV9:
          targetVersionQuestions = questionsLLCv9;
          break; 
        case LimitedLiabilityCompanyV10:
          targetVersionQuestions = questionsLLCv10;
          break;
        case LimitedLiabilityCompanyV11:
          targetVersionQuestions = questionsLLCv11;
          break;
        case LimitedLiabilityCompanyV12:
          targetVersionQuestions = questionsLLCv12;
          break;
        case LimitedLiabilityCompanyV13:
          targetVersionQuestions = questionsLLCv13;
          break;
        case LimitedLiabilityCompanyV11_ecp:
          targetVersionQuestions = questionsLLCv11_ecp;
          break;

        case ForesiteV1:
          targetVersionQuestions = questionsForesitev1;
          break;
        case ForesiteV2:
          targetVersionQuestions = questionsForesitev2;
          break;
        case ForesiteV3:
          targetVersionQuestions = questionsForesitev3;
          break;
        case ForesiteV4:
          targetVersionQuestions = questionsForesitev4;
          break;
        case ForesiteV5:
          targetVersionQuestions = questionsForesitev5;
          break;
        case ForesiteV6:
          targetVersionQuestions = questionsForesitev6;
          break;
        case ForesiteV7:
          targetVersionQuestions = questionsForesitev7;
          break;
        case ForesiteV8:
          targetVersionQuestions = questionsForesitev8;
          break;
        case ForesiteV9:
          targetVersionQuestions = questionsForesitev9;
          break;

        case QuestaCapitalV1:
          targetVersionQuestions = questionsQuestaCapitalv1;
          break;
        case QuestaCapitalV2:
          targetVersionQuestions = questionsQuestaCapitalv2;
          break;
        case QuestaCapitalV3:
          targetVersionQuestions = questionsQuestaCapitalv3;
          break;
        case QuestaCapitalV4:
          targetVersionQuestions = questionsQuestaCapitalv4;
          break;
        case QuestaCapitalV5:
          targetVersionQuestions = questionsQuestaCapitalv5;
          break;
        case QuestaCapitalV6:
          targetVersionQuestions = questionsQuestaCapitalv6;
          break;
        case QuestaCapitalV7:
          targetVersionQuestions = questionsQuestaCapitalv7;
          break;
        case QuestaCapitalV8:
          targetVersionQuestions = questionsQuestaCapitalv8;
          break;
        case QuestaCapitalV9:
          targetVersionQuestions = questionsQuestaCapitalv9;
          break;

        case InitializedV1:
          targetVersionQuestions = questionsInitializedv1;
          break;
        case InitializedV2:
          targetVersionQuestions = questionsInitializedv2;
          break;
        case InitializedV3:
          targetVersionQuestions = questionsInitializedv3;
          break;
        case InitializedV4:
          targetVersionQuestions = questionsInitializedv4;
          break;
        case InitializedV5:
          targetVersionQuestions = questionsInitializedv5;
          break;
        case InitializedV6:
          targetVersionQuestions = questionsInitializedv6;
          break;
        case InitializedV7:
          targetVersionQuestions = questionsInitializedv7;
          break;
        case InitializedV8:
          targetVersionQuestions = questionsInitializedv8;
          break;
        case InitializedV9:
          targetVersionQuestions = questionsInitializedv9;
          break;

        case HCMV1:
          targetVersionQuestions = questionsHCMv1;
          break;
        case HCMV2:
          targetVersionQuestions = questionsHCMv2;
          break;
        case HCMV3:
          targetVersionQuestions = questionsHCMv3;
          break;
        case HCMV4:
          targetVersionQuestions = questionsHCMv4;
          break;
        case HCMV5:
          targetVersionQuestions = questionsHCMv5;
          break;
        case HCMV6:
          targetVersionQuestions = questionsHCMv6;
          break;

        case ForesiteLabsV1:
          targetVersionQuestions = questionsForesiteLabsv1;
          break;
        case ForesiteLabsV2:
          targetVersionQuestions = questionsForesiteLabsv2;
          break;
        case ForesiteLabsV3:
          targetVersionQuestions = questionsForesiteLabsv3;
          break;
        case ForesiteLabsV4:
          targetVersionQuestions = questionsForesiteLabsv4;
          break;
        case ForesiteLabsV5:
          targetVersionQuestions = questionsForesiteLabsv5;
          break;
        case ForesiteLabsV6:
          targetVersionQuestions = questionsForesiteLabsv6;
          break;
        case ForesiteLabsV7:
          targetVersionQuestions = questionsForesiteLabsv7;
          break;
        case ForesiteLabsV8:
          targetVersionQuestions = questionsForesiteLabsv8;
          break;

        case AudereV1:
          targetVersionQuestions = questionsAuderev1;
          break;
        case AudereV2:
          targetVersionQuestions = questionsAuderev2;
          break;
        case AudereV3:
          targetVersionQuestions = questionsAuderev3;
          break;
        case AudereV4:
          targetVersionQuestions = questionsAuderev4;
          break;

        case CaymanV1:
          targetVersionQuestions = questionsCaymanv1;
          break;
        case CaymanV2:
          targetVersionQuestions = questionsCaymanv2;
          break;
        case CaymanV3:
          targetVersionQuestions = questionsCaymanv3;
          break;
        case CaymanV4:
          targetVersionQuestions = questionsCaymanv4;
          break;
        case CaymanV5:
          targetVersionQuestions = questionsCaymanv5;
          break;
        case CaymanV6:
          targetVersionQuestions = questionsCaymanv6;
          break;
        case CaymanV7:
          targetVersionQuestions = questionsCaymanv7;
          break;

        case LPABBRV1:
          targetVersionQuestions = questionsLPAbbrv1;
          break;
        case LPABBRV1_1:
          targetVersionQuestions = questionsLPAbbrv1_1;
          break;
        case LPABBRV2:
          targetVersionQuestions = questionsLPAbbrv2;
          break;
        case LPABBRV3:
          targetVersionQuestions = questionsLPAbbrv3;
          break;
        case LPABBRV3_1:
          targetVersionQuestions = questionsLPAbbrv3_1;
          break;
        case LPABBRV4:
          targetVersionQuestions = questionsLPAbbrv4;
          break;
        case LPABBRV5:
          targetVersionQuestions = questionsLPAbbrv5;
          break;
        case LPABBRV6:
          targetVersionQuestions = questionsLPAbbrv6;
          break;
        case LPABBRV7:
          targetVersionQuestions = questionsLPAbbrv7;
          break;
        case LPABBRV8:
          targetVersionQuestions = questionsLPAbbrv8;
          break;

        case IOLARV1:
          targetVersionQuestions = questionsIolarv1;
          break;
        case IOLARV2:
          targetVersionQuestions = questionsIolarv2;
          break;
        case IOLARV3:
          targetVersionQuestions = questionsIolarv3;
          break;
        case IOLARV4:
          targetVersionQuestions = questionsIolarv4;
          break;

        case OSAGEV1:
          targetVersionQuestions = questionsOSAGEv1;
          break;
        case OSAGEV2:
          targetVersionQuestions = questionsOSAGEv2;
          break;
        case OSAGEV3:
          targetVersionQuestions = questionsOSAGEv3;
          break;
        case OSAGEV4:
          targetVersionQuestions = questionsOSAGEv4;
          break;

        case NewLimitedPartnerV1:
          targetVersionQuestions = questionsNewLimitedPartnerv1;
          break;
        case NewLimitedPartnerV2:
          targetVersionQuestions = questionsNewLimitedPartnerv2;
          break;
        case NewLimitedPartnerV3:
          targetVersionQuestions = questionsNewLimitedPartnerv3;
          break;
        case NewLimitedPartnerV4:
          targetVersionQuestions = questionsNewLimitedPartnerv4;
          break;

        case TcgCrossOverV1:
          targetVersionQuestions = questionsTcgCrossOverv1;
          break;
        case TcgCrossOverV2:
          targetVersionQuestions = questionsTcgCrossOverv2;
          break;
        case TcgCrossOverV3:
          targetVersionQuestions = questionsTcgCrossOverv3;
          break;
        case TcgCrossOverV4:
          targetVersionQuestions = questionsTcgCrossOverv4;
          break;

        case TcgCrossOverCaymanV1:
          targetVersionQuestions = questionsTcgCrossOverCaymanv1;
          break;
        case TcgCrossOverCaymanV2:
          targetVersionQuestions = questionsTcgCrossOverCaymanv2;
          break;

        case BITKRAFTV1:
          targetVersionQuestions = questionsBitKraftv1;
          break;
        case BITKRAFTV2:
          targetVersionQuestions = questionsBitKraftv2;
          break;
        case BITKRAFTV3:
          targetVersionQuestions = questionsBitKraftv3;
          break;
        case BITKRAFTV4:
          targetVersionQuestions = questionsBitKraftv4;
          break;

        case BitkraftIndiaV1:
          targetVersionQuestions = questionsBitKraftIndiav1;
          break;
        case BitkraftIndiaV2:
          targetVersionQuestions = questionsBitKraftIndiav2;
          break;

        case ElephantPartnerV1:
           targetVersionQuestions = questionsElephantPartnerv1;
          break;
        case ElephantPartnerV2:
           targetVersionQuestions = questionsElephantPartnerv2;
          break;
        case ElephantPartnerV3:
           targetVersionQuestions = questionsElephantPartnerv3;
          break;
        case ElephantPartnerV4:
          targetVersionQuestions = questionsElephantPartnerv4;
          break;

        case FireworkV1:
          targetVersionQuestions = questionsFLPv1;
          break;
        case FireworkV2:
          targetVersionQuestions = questionsFLPv2;
          break;
        case FireworkV3:
          targetVersionQuestions = questionsFLPv3;
          break;
        case FireworkV4:
          targetVersionQuestions = questionsFLPv4;
          break;

        case PrometheanV1:
          targetVersionQuestions = questionsPrometheanv1;
          break;
        case PrometheanV2:
          targetVersionQuestions = questionsPrometheanv2;
          break;
        case PrometheanV3:
          targetVersionQuestions = questionsPrometheanv3;
          break;
        case PrometheanV4:
          targetVersionQuestions = questionsPrometheanv4;
          break;
        
        case AccelV1:
          targetVersionQuestions = questionsAccelv1;
          break;
        case AccelV2:
          targetVersionQuestions = questionsAccelv2;
          break;
        case AccelV3:
          targetVersionQuestions = questionsAccelv3;
          break;
        case AccelV4:
          targetVersionQuestions = questionsAccelv4;
          break;
        
        case AccelMainV1:
          targetVersionQuestions = questionsAccelMainv1;
          break;
        case AccelMainV2:
          targetVersionQuestions = questionsAccelMainv2;
          break;
        case AccelMainV3:
          targetVersionQuestions = questionsAccelMainv3;
          break;
        
        case AccelEntrepreneursV1:
          targetVersionQuestions = questionsAccelEntrepreneursv1;
          break;
        case AccelEntrepreneursV2:
          targetVersionQuestions = questionsAccelEntrepreneursv2;
          break;

        case AccelCircleV1:
          targetVersionQuestions = questionsAccelCirclev1;
          break;
        case AccelCircleV2:
          targetVersionQuestions = questionsAccelCirclev2;
          break;

        case AccelEtpnReturningV1:
          targetVersionQuestions = questionsAccelEtpnReturningv1;
          break;
        case AccelEtpnReturningMultiV1:
        case AccelEtpnReturningV2:
          targetVersionQuestions = questionsAccelEtpnReturningv2;
          break;

        case LPMULTIFUNDV1:
          targetVersionQuestions = questionsLPMultiFundv1;
          break;
        case LPMULTIFUNDV2:
          targetVersionQuestions = questionsLPMultiFundv2;
          break;
        case LPMULTIFUNDV2_1:
          targetVersionQuestions = questionsLPMultiFundv2_1;
          break;
        case LPMULTIFUNDV3:
          targetVersionQuestions = questionsLPMultiFundv3;
          break;
        case LPMULTIFUNDV4:
          targetVersionQuestions = questionsLPMultiFundv4;
          break;
        case LPMULTIFUNDV5:
          targetVersionQuestions = questionsLPMultiFundv5;
          break;
        case LPMULTIFUNDV6:
          targetVersionQuestions = questionsLPMultiFundv6;
          break;
        case LPMULTIFUNDV7:
          targetVersionQuestions = questionsLPMultiFundv7;
          break;

        case LimitedPartnershipMFV1:
          targetVersionQuestions = questionsLimitedPartnershipMFv1;
          break;
        case LimitedPartnershipMFV2:
          targetVersionQuestions = questionsLimitedPartnershipMFv2;
          break;
        case LimitedPartnershipMFV2_1:
          targetVersionQuestions = questionsLimitedPartnershipMFv2_1;
          break;
        case LimitedPartnershipMFV3:
          targetVersionQuestions = questionsLimitedPartnershipMFv3;
          break;
        case LimitedPartnershipMFV4:
          targetVersionQuestions = questionsLimitedPartnershipMFv4;
          break;
        case LimitedPartnershipMFV5:
          targetVersionQuestions = questionsLimitedPartnershipMFv5;
          break;
        case LimitedPartnershipMFV6:
          targetVersionQuestions = questionsLimitedPartnershipMFv6;
          break;
        case LimitedPartnershipMFV6_SparkCapital:
          targetVersionQuestions = questionsLimitedPartnershipMFv6_SparkCapital;
          break;
        case LimitedPartnershipMFV7:
          targetVersionQuestions = questionsLimitedPartnershipMFv7;
          break;

        case PictureCapitalV1:
          targetVersionQuestions = questionsPictureCapitalv1;
          break;
        case PictureCapitalV2:
          targetVersionQuestions = questionsPictureCapitalv2;
          break;
        case PictureCapitalV3:
          targetVersionQuestions = questionsPictureCapitalv3;
          break;

        case BenchmarkMultiFundV1:
          targetVersionQuestions = questionsBenchmarkMultiFundv1;
          break;
        case BenchmarkMultiFundV2:
          targetVersionQuestions = questionsBenchmarkMultiFundv2;
          break;
        case BenchmarkMultiFundV3:
          targetVersionQuestions = questionsBenchmarkMultiFundv3;
          break;

        case SROneV1:
          targetVersionQuestions = questionsSROnev1;
          break;
        case SROneV2:
          targetVersionQuestions = questionsSROnev2;
          break;
        case SROneV3:
          targetVersionQuestions = questionsSROnev3;
          break;

        case TerrariumV1:
          targetVersionQuestions = questionsTerrariumv1;
          break;
        case TerrariumV2:
          targetVersionQuestions = questionsTerrariumv2;
          break;

        case NICFUNDV1:
          targetVersionQuestions = questionsNICFundv1;
          break;
        case NICFUNDV2:
          targetVersionQuestions = questionsNICFundv2;
          break;
        case NICFUNDV3:
          targetVersionQuestions = questionsNICFundv3;
          break;

        default:
          console.error('No current version to set the version questions !!!!');
      }

      if (!questionnaireContext.currentVersionQuestions.length) {
        this.props.setVersionQuestions(targetVersionQuestions);
      }
      if (questionnaireContext.investorFund.generalInfo) {
        const isNatural = this.isNaturalPerson();
        this.props.isNaturalPerson(isNatural);

        this.evaluateMultiSelectQuestions(isNatural, targetVersionQuestions);
      }
    }
    // currently it doesn't trigger if the entity doesn't change from natural to corporation , check if it is needed
    const hasNewTypes =
      JSON.stringify(
        prevProps.questionnaireContext.investorFund.generalInfo
      ) !== JSON.stringify(questionnaireContext.investorFund.generalInfo);
    if (hasNewTypes) {
       const currentIsNaturalPerson = this.isNaturalPerson();
       this.evaluateMultiSelectQuestions(
          currentIsNaturalPerson,
          questionnaireContext.currentVersionQuestions
       );
      this.props.isNaturalPerson(currentIsNaturalPerson);
    }
    const questionnaireHasUpdates =
      prevProps.questionnaireContext.investorFund.questionnaire &&
      prevProps.questionnaireContext.investorFund.questionnaire.questions &&
      questionnaireContext.investorFund.questionnaire &&
      questionnaireContext.investorFund.questionnaire.questions &&
      JSON.stringify(
        prevProps.questionnaireContext.investorFund.questionnaire.questions
      ) !==
        JSON.stringify(
          questionnaireContext.investorFund.questionnaire.questions
        );

    if (
      questionnaireHasUpdates &&
      Object.entries(questionnaireContext.currentVersionQuestions).length
    ) {
      const currentIsNaturalPerson = this.isNaturalPerson();
      this.evaluateMultiSelectQuestions(
        currentIsNaturalPerson,
        questionnaireContext.currentVersionQuestions
      );
      this.props.isNaturalPerson(currentIsNaturalPerson);
    }
  }
  componentWillUnmount() {}

  fetchInvestorInfo = async () => {
    const { investor, investorFund } = this.props.questionnaireContext;
    const questionnaireTab = window.location.href.includes('questionnaire');
    if (
      investorFund.updateInvestorInfo &&
      questionnaireTab &&
      !restrictAccess
    ) {
      restrictAccess = true;
      let updateData = {};
      updateData.questionFields = [];
      updateData._id = investorFund._id;
      updateData.limitedPartnerFund = investorFund._id;
      updateData.iqVersion = investorFund.questionnaire.iqVersion;
      const { data } = await axios.post(
        `${API_URL()}/access/questionnaire/updateInvestorInfo`,
        updateData,
        SERVICE_CONFIG_QUESTIONNAIRE()
      );

      if (data.success) {
        this.props.setInvestorFund(data.investorFund);
      } else {
        this.props.renderNotification(
          'error',
          'Error updating questionnaire field',
          data.message
        );
      }
    }
  };

  isNaturalPerson = () => {
    const {
      questionnaireContext: {
        investorFund: { generalInfo },
      },
    } = this.props;
    return (
      generalInfo &&
      generalInfo.types &&
      (generalInfo.types.indexOf('Natural Person') > -1 ||
        generalInfo.types.indexOf('IRA') > -1 ||
        generalInfo.types.indexOf('Tenants in Common') > -1 ||
        generalInfo.types.indexOf('Joint Tenants with Right of Survivorship') > -1 ||
        generalInfo.types.indexOf('Other - Individual') > -1)
    );
   
  };

  isFundCreatedAfter = (fundVersion) => {
    const { questionnaireContext } = this.props;
    const fund = questionnaireContext.fund;
    const fundCreatedDate = fund.createdAt;

    const fundVersionDate = new Date(`01-${fundVersion}`)
    const createdFundDate = new Date(fundCreatedDate);

    return createdFundDate > fundVersionDate;
  }

  parseQuestionDataFromId = (_identifier) => {
    const { questionnaireContext } = this.props;
    let targetQuestion = null;
    const questions =
      questionnaireContext.investorFund.questionnaire.questions || [];
    if (questions && questions.length) {
      targetQuestion = questions.find(
        (_q) => _q.descriptionIdentifier === _identifier
      );
      if (targetQuestion) {
        return targetQuestion;
      }
    }
    return targetQuestion;
  };

  questionIsAnswered = (_identifier) =>
    !!this.parseQuestionDataFromId(_identifier);
  // in case of changing entities or different answers that require removing a certain questions
  cleanupInvalidQuestions = (_isNaturalPerson, _currentVersionQuestions) => {
    const {
      accreditedInvestorRepresentations,
      qualifiedPurchaserRepresentations,
      foreignPersonStatusRepresentations,
      foreignPersonStatusRepresentations2,
      identificationofSpecialEntities,
    } = _currentVersionQuestions;

    let isEntityIRA = false;
    const generalInfoJSON = JSON.parse(sessionStorage.getItem('generalInfo'));
    if (generalInfoJSON && generalInfoJSON.types) {
      isEntityIRA = generalInfoJSON.types.includes('IRA');
    }

    const removeList = [];
    if (_isNaturalPerson) {
      // clean all specialEntities
      for (const specialEntityQuestion of identificationofSpecialEntities) {
        if (this.questionIsAnswered(specialEntityQuestion.id)) {
          removeList.push(specialEntityQuestion.id);
        }
      }
      // foreign 2,3,4
      if (foreignPersonStatusRepresentations) {
        for (const foreignPersonQuestion of foreignPersonStatusRepresentations) {
          if (
            foreignPersonQuestion.id === IqID.id_foreign_person_2 ||
            foreignPersonQuestion.id === IqID.id_foreign_person_3 ||
            foreignPersonQuestion.id === IqID.id_foreign_person_4
          ) {
            if (this.questionIsAnswered(foreignPersonQuestion.id)) {
              removeList.push(foreignPersonQuestion.id);
            }
          }
        }
      }
      if (foreignPersonStatusRepresentations2) {
        for (const foreignPersonQuestion2 of foreignPersonStatusRepresentations2) {
          if (
            foreignPersonQuestion2.id === IqID.id_foreign_person_2_1 ||
            foreignPersonQuestion2.id === IqID.id_foreign_person_2_2 ||
            foreignPersonQuestion2.id === IqID.id_foreign_person_2_or
          ) {
            if (this.questionIsAnswered(foreignPersonQuestion2.id)) {
              removeList.push(foreignPersonQuestion2.id);
            }
          }
        }
      }
      // qualifiedPurchaser 3,4,5,6
      for (const qualifiedPurchaserQuestion of qualifiedPurchaserRepresentations) {
        if (
          qualifiedPurchaserQuestion.id ===
            IqID.id_purchase_representations_3 ||
          qualifiedPurchaserQuestion.id ===
            IqID.id_purchase_representations_4 ||
          qualifiedPurchaserQuestion.id ===
            IqID.id_purchase_representations_5 ||
          qualifiedPurchaserQuestion.id === 
            IqID.id_purchase_representations_6 ||
          qualifiedPurchaserQuestion.id === 
            IqID.id_purchase_representations_7
        ) {
          if (this.questionIsAnswered(qualifiedPurchaserQuestion.id)) {
            removeList.push(qualifiedPurchaserQuestion.id);
          }
        }
      }
      // accreditedInvestorReps 3,4,5,6,7,8,
      for (const accreditedInvestorQuestion of accreditedInvestorRepresentations) {
        if (
          accreditedInvestorQuestion.id ===
            IqID.id_investor_representations_3 ||
          accreditedInvestorQuestion.id ===
            IqID.id_investor_representations_4 ||
          accreditedInvestorQuestion.id ===
            IqID.id_investor_representations_5 ||
          accreditedInvestorQuestion.id ===
            IqID.id_investor_representations_6 ||
          accreditedInvestorQuestion.id ===
            IqID.id_investor_representations_7 ||
          accreditedInvestorQuestion.id ===
            IqID.id_investor_representations_8 ||
          accreditedInvestorQuestion.id ===
           IqID.id_investor_representations_9 ||
          accreditedInvestorQuestion.id ===
            IqID.id_investor_representations_14 ||
          accreditedInvestorQuestion.id ===
            IqID.id_investor_representations_15
        ) {
          if (this.questionIsAnswered(accreditedInvestorQuestion.id)) {
            removeList.push(accreditedInvestorQuestion.id);
          }
        }
      }
    } else if (!_isNaturalPerson) {
      // foreign 1 ??
      if (foreignPersonStatusRepresentations) {
        for (const foreignPersonQuestion of foreignPersonStatusRepresentations) {
          if (foreignPersonQuestion.id === IqID.id_foreign_person_1) {
            if (this.questionIsAnswered(foreignPersonQuestion.id)) {
              removeList.push(foreignPersonQuestion.id);
            }
          }
        }
      }

      // qualifiedPurchaser 1
      for (const qualifiedPurchaserQuestion of qualifiedPurchaserRepresentations) {
        if (
					qualifiedPurchaserQuestion.id === IqID.id_purchase_representations_1 ||
					qualifiedPurchaserQuestion.id === IqID.id_purchase_representations_8
				) {
					if (this.questionIsAnswered(qualifiedPurchaserQuestion.id) && !isEntityIRA) {
						removeList.push(qualifiedPurchaserQuestion.id);
					}
				}
      }
      // accreditedInvestorReps 1,2
      for (const accreditedInvestorQuestion of accreditedInvestorRepresentations) {
        if (
          accreditedInvestorQuestion.id ===
            IqID.id_investor_representations_1 ||
          accreditedInvestorQuestion.id === IqID.id_investor_representations_2
        ) {
          if (this.questionIsAnswered(accreditedInvestorQuestion.id)) {
            removeList.push(accreditedInvestorQuestion.id);
          }
        }
      }
    }
    return removeList;
  };

  evaluateMultiSelectQuestions = (
    _isNaturalPerson,
    _currentVersionQuestions
  ) => {
    const {
      questionnaireContext: {
        investorFund: { questionnaire: currentSavedQuestionnaire },
        fund,
      },
    } = this.props;
    const {
      accreditedInvestorRepresentations,
      qualifiedClientRepresentations,
      qualifiedPurchaserRepresentations,
      foreignPersonStatusRepresentations,
      foreignPersonStatusRepresentations2,
      identificationofSpecialEntities,
      wiringBankStatus,
      exemptedEntityStatus,
    } = _currentVersionQuestions;
    const optionalsList = [];
    const removeList = []; // answers that need to be removed entirely , verify its not  the same behavior from clearAnswer list
    const valueUpdateList = [];
    const disabledList = []; // list of what should be enabled or disabled in the questionnaire

    let isEntityIRA = false;
    const generalInfoJSON = JSON.parse(sessionStorage.getItem('generalInfo'));
    if (generalInfoJSON && generalInfoJSON.types) {
      isEntityIRA = generalInfoJSON.types.includes('IRA');
    }

    if (
      currentSavedQuestionnaire &&
      currentSavedQuestionnaire.questions &&
      Object.entries(_currentVersionQuestions).length
    ) {
      const wiringBank1 = this.parseQuestionDataFromId(
        IqID.id_wiring_bank_status_1
      );
      if (!wiringBank1 || wiringBank1.answer === 'Yes') {
        const wiringBank1Opt = this.parseQuestionDataFromId(
          IqID.id_wiring_bank_status_1_opt
        );
        if (wiringBank1Opt) {
          removeList.push(IqID.id_wiring_bank_status_1_opt);
        }
      }

      const id_investor_status_5_a = this.parseQuestionDataFromId(
        IqID.id_investor_status_5_a
      );
      const id_investor_status_5_b = this.parseQuestionDataFromId(
        IqID.id_investor_status_5_b
      );
      const id_investor_status_5_c = this.parseQuestionDataFromId(
        IqID.id_investor_status_5_c
      );
      const id_investor_status_5_d = this.parseQuestionDataFromId(
        IqID.id_investor_status_5_d
      );
      const id_investor_status_5_e = this.parseQuestionDataFromId(
        IqID.id_investor_status_5_e
      );

      if (
        id_investor_status_5_a &&
        id_investor_status_5_a.answer === 'No' &&
        id_investor_status_5_b &&
        id_investor_status_5_b.answer === 'No' &&
        id_investor_status_5_c &&
        id_investor_status_5_c.answer === 'No' &&
        id_investor_status_5_d &&
        id_investor_status_5_d.answer === 'No' &&
        id_investor_status_5_e &&
        id_investor_status_5_e.answer === 'No'
      ) {
        removeList.push(IqID.id_investor_status_5_f);
      }

      // if the entity changes clear all needed questions
      const id_investor_status_1_Data = this.parseQuestionDataFromId(
        IqID.id_investor_status_1
      );

      if (
        _isNaturalPerson &&
        id_investor_status_1_Data &&
        id_investor_status_1_Data.answer === 'No'
      ) {
        valueUpdateList.push({ id: IqID.id_investor_status_1, value: 'Yes' });
      } else if (
        !_isNaturalPerson &&
        id_investor_status_1_Data &&
        id_investor_status_1_Data.answer === 'Yes'
      ) {
        valueUpdateList.push({ id: IqID.id_investor_status_1, value: 'No' });
      }


       const id_covered_investor_status_or_Data = this.parseQuestionDataFromId(
        IqID.id_covered_investor_status_or
      );   

      const id_restricted_person_status_or_Data = this.parseQuestionDataFromId(
        IqID.id_restricted_person_status_or
      );   

       const { questionnaireContext } = this.props;
        const SROne = questionnaireContext.currentVersion && questionnaireContext.currentVersion === SROneV1;
        const foresiteLabs = questionnaireContext.currentVersion && questionnaireContext.currentVersion === ForesiteLabsV6;

      if (SROne) {

        if (_isNaturalPerson) {
          const toDisable = [
          IqID.id_sr_one_part_a_3,
          IqID.id_sr_one_part_a_3_or,
          IqID.id_sr_one_part_a_3_a,
          IqID.id_sr_one_part_a_3_b,
          IqID.id_sr_one_part_a_3_c,
          IqID.id_sr_one_part_b_3,
          IqID.id_sr_one_part_b_3_or,
          IqID.id_sr_one_part_b_3_a,
          IqID.id_sr_one_part_b_3_b,
          IqID.id_sr_one_part_b_3_c,
          IqID.id_sr_one_part_b_or,
          IqID.id_sr_one_part_a_or,
        ]
        disabledList.push(...toDisable);
        removeList.push(...toDisable);
        } else if (!_isNaturalPerson) {
          const toDisable = [
          IqID.id_sr_one_part_a_1,
          IqID.id_sr_one_part_a_2,
          IqID.id_sr_one_part_b_1,
          IqID.id_sr_one_part_b_2,
          IqID.id_sr_one_part_b_1_a,
          IqID.id_sr_one_part_b_1_b,
          IqID.id_sr_one_part_b_1_c,
          IqID.id_sr_one_part_b_1_text_note,
          ];
         disabledList.push(...toDisable);
         removeList.push(...toDisable);
        }
        
      }

      if (foresiteLabs) {
        if (_isNaturalPerson) {
          const toDisable = [
            IqID.id_foresiteEntities,
            IqID.id_foresiteEntities_opt,
          ];
           disabledList.push(...toDisable);
           removeList.push(...toDisable);
        
        } else if (!_isNaturalPerson) {
            const toDisable = [
            IqID.id_foresitePublicCompanyAffiliation,
            IqID.id_foresitePublicCompanyAffiliation_opt,
          ];
           disabledList.push(...toDisable);
           removeList.push(...toDisable);
        }

      }

      if(exemptedEntityStatus) {
        for (let i = 0; i < exemptedEntityStatus.length; i += 1) {
          if (_isNaturalPerson) {
              disabledList.push(exemptedEntityStatus[i].id);
            }
          else if (!_isNaturalPerson &&
            id_covered_investor_status_or_Data && 
            id_covered_investor_status_or_Data.answer === 'Yes' &&
            id_restricted_person_status_or_Data && 
            id_restricted_person_status_or_Data.answer === 'Yes'
            ) {
              disabledList.push(exemptedEntityStatus[i].id);
          }  
        }
      }

      if (accreditedInvestorRepresentations) {
        for (let i = 0; i < accreditedInvestorRepresentations.length; i += 1) {
          const question = this.parseQuestionDataFromId(
            accreditedInvestorRepresentations[i].id
          );

          if (_isNaturalPerson) {
            if (
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_3 ||
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_4 ||
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_5 ||
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_6 ||
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_6_extra ||
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_8 ||
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_9 ||
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_11 ||
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_14 ||
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_15
            ) {
              if (question && question.answer === 'Yes') {
                removeList.push(accreditedInvestorRepresentations[i].id);
              }
            }
          }
          if (!_isNaturalPerson) {
            if (
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_1 ||
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_2 ||
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_10
            ) {
              if (question && question.answer === 'Yes') {
                removeList.push(accreditedInvestorRepresentations[i].id);
              }
            }
          }
        }
        for (let i = 0; i < accreditedInvestorRepresentations.length; i += 1) {
          if (_isNaturalPerson) {
            if (
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_3 ||
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_4 ||
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_5 ||
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_6 ||
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_6_extra ||
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_7 ||
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_8 ||
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_9 ||
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_11 ||
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_14 ||
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_15
            ) {
              disabledList.push(accreditedInvestorRepresentations[i].id);
            }
          }
          if (!_isNaturalPerson) {
            if (
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_1 ||
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_2 ||
              accreditedInvestorRepresentations[i].id ===
                IqID.id_investor_representations_10
            ) {
              disabledList.push(accreditedInvestorRepresentations[i].id);
            }
          }
          const id_investor_representations_or_Data =
            this.parseQuestionDataFromId(IqID.id_investor_representations_or);
          if (
            id_investor_representations_or_Data &&
            id_investor_representations_or_Data.answer === 'Yes'
          ) {
            accreditedInvestorRepresentations.forEach((item) => {
              if (item.id !== IqID.id_investor_representations_or) {
                if (
                  !disabledList.includes(
                    'accredited-investor-principal-introduction'
                  )
                ) {
                  disabledList.push(
                    'accredited-investor-principal-introduction'
                  );
                }
              }
            });
          }
        }
      }

      if (foreignPersonStatusRepresentations) {
        for (let i = 0; i < foreignPersonStatusRepresentations.length; i += 1) {
          if (
            _isNaturalPerson &&
            (foreignPersonStatusRepresentations[i].id ===
              IqID.id_foreign_person_2 ||
              foreignPersonStatusRepresentations[i].id ===
                IqID.id_foreign_person_3 ||
              foreignPersonStatusRepresentations[i].id ===
                IqID.id_foreign_person_4)
          ) {
            disabledList.push(foreignPersonStatusRepresentations[i].id);
          } else if (
            !_isNaturalPerson &&
            foreignPersonStatusRepresentations[i].id ===
              IqID.id_foreign_person_1
          ) {
            disabledList.push(foreignPersonStatusRepresentations[i].id);
          }
        }
      }

      if (foreignPersonStatusRepresentations2) {
        for (
          let i = 0;
          i < foreignPersonStatusRepresentations2.length;
          i += 1
        ) {
          if (
            _isNaturalPerson &&
            (foreignPersonStatusRepresentations2[i].id ===
              IqID.id_foreign_person_2_1 ||
              foreignPersonStatusRepresentations2[i].id ===
                IqID.id_foreign_person_2_2 ||
              foreignPersonStatusRepresentations2[i].id ===
                IqID.id_foreign_person_2_or)
          ) {
            disabledList.push(foreignPersonStatusRepresentations2[i].id);
          }
        }
      }

      if (qualifiedPurchaserRepresentations) {
        let isQualifiedPurchaser = false;
        for (const qualifiedPurchaserQuestion of qualifiedPurchaserRepresentations) {
          const questionData = this.parseQuestionDataFromId(
            qualifiedPurchaserQuestion.id
          );
          if (
            qualifiedPurchaserQuestion.id !==
              IqID.id_purchase_representations_or &&
            questionData &&
            questionData.answer === 'Yes'
          ) {
            isQualifiedPurchaser = true;
          }
        }
        if (isQualifiedPurchaser) {
          qualifiedClientRepresentations.forEach((item) => {
            disabledList.push(item.id);
            // if any questions are answered from clientReps need to remove
            if (this.questionIsAnswered(item.id)) {
              removeList.push(item.id);
            }
          });
          disabledList.push('qualified-client-principal-introduction');
        }

        for (let i = 0; i < qualifiedPurchaserRepresentations.length; i += 1) {
          if (_isNaturalPerson) {
            if (
              qualifiedPurchaserRepresentations[i].id ===
                IqID.id_purchase_representations_3 ||
              qualifiedPurchaserRepresentations[i].id ===
                IqID.id_purchase_representations_4 ||
              qualifiedPurchaserRepresentations[i].id ===
                IqID.id_purchase_representations_5 ||
              qualifiedPurchaserRepresentations[i].id ===
                IqID.id_purchase_representations_6 ||
              qualifiedPurchaserRepresentations[i].id ===
                IqID.id_purchase_representations_7
            ) {
              disabledList.push(qualifiedPurchaserRepresentations[i].id);
            }
          }
          if (!_isNaturalPerson) {
            if (
              (qualifiedPurchaserRepresentations[i].id === IqID.id_purchase_representations_8 ||
              qualifiedPurchaserRepresentations[i].id === IqID.id_purchase_representations_1) &&
              !isEntityIRA
            ) {
              disabledList.push(qualifiedPurchaserRepresentations[i].id);
            }
          }
          const id_purchase_representations_or_Data =
            this.parseQuestionDataFromId(IqID.id_purchase_representations_or);
          if (
            id_purchase_representations_or_Data &&
            id_purchase_representations_or_Data.answer === 'Yes'
          ) {
            qualifiedPurchaserRepresentations.forEach((item) => {
              if (item.id !== IqID.id_purchase_representations_or) {
                if (
                  !disabledList.includes(
                    'qualified-purchaser-principal-introduction'
                  )
                ) {
                  disabledList.push(
                    'qualified-purchaser-principal-introduction'
                  );
                }
              }
            });
          }
        }
      }

      // checkBadActorQuestionAbility =()=> availability? FIXME
      // check this part better looks likes if id_investor_status_5_f, and the rest isnt selected the it disables the other set of questions

      if (identificationofSpecialEntities) {
        // special entities optionals logic
        const id_special_entities_1_b_Data = this.parseQuestionDataFromId(
          IqID.id_special_entities_1_b
        );
        if (
          id_special_entities_1_b_Data &&
          id_special_entities_1_b_Data.answer === 'Yes'
        ) {
          optionalsList.push(IqID.id_special_entities_1_b_opt);
        }

        let clearPotentialLookthroughEntity_e_opt = true;
        for (const specialEntity of identificationofSpecialEntities) {
          if (specialEntity.id.includes(IqID.id_special_entities_2)) {
            const currentQuestion = this.parseQuestionDataFromId(
              specialEntity.id
            );
            if (currentQuestion && currentQuestion.answer === 'Yes') {
              clearPotentialLookthroughEntity_e_opt = false;
              if (!optionalsList.includes(IqID.id_special_entities_2_e_opt)) {
                optionalsList.push(IqID.id_special_entities_2_e_opt);
              }
            }
          }
        }
        if (clearPotentialLookthroughEntity_e_opt) {
          const special2eOpt = this.parseQuestionDataFromId(
            IqID.id_special_entities_2_e_opt
          );
          if (special2eOpt) {
            removeList.push(IqID.id_special_entities_2_e_opt);
          }
        }

        const { questionnaireContext } = this.props;
        const investorFund = questionnaireContext.investorFund;
        const isBlankCapitalCommitment = investorFund.fund && investorFund.fund.requireCapitalCommitment === 'blank';
        const currentVersion = questionnaireContext && questionnaireContext.currentVersion;
        const isAccelMain = questionnaireContext.currentVersion && questionnaireContext.currentVersion === AccelMainV1;
        

        if (currentVersion && (currentVersion.includes(SorensonV1) || currentVersion.includes(SorensonV2) || currentVersion.includes(SorensonV3))) {
           const specialEntities4A = this.parseQuestionDataFromId(IqID.id_special_entities_4_a);

           if (!specialEntities4A || (specialEntities4A && specialEntities4A.answer !== 'Yes')) {
            removeList.push(IqID.id_special_entities_4_b)
            disabledList.push(IqID.id_special_entities_4_b)
           }
        }

        if (currentVersion && (currentVersion.includes(AltimeterAMLV1))) {
          const exhibitDAml = _currentVersionQuestions.exhibitDAml;
          if (
            exhibitDAml &&
            exhibitDAml.partBCategories.some((item) => {
              if (item[0] === 'aml_part_b_foreign_governmental_entity') return false;
              const question = this.parseQuestionDataFromId(item[0]);
              return question && question.answer === 'Yes';
            })
          ) {
            const partCQuestionIds = [
              ...exhibitDAml.beneficialOwnership.map((item) => item.id),
              ...Object.keys(exhibitDAml.owners).reduce(
                (ids, number) => ids.concat(Object.values(exhibitDAml.owners[number])),
                []
              ),
              ...exhibitDAml.controlPerson.map((item) => item.id),
            ];
            disabledList.push(...partCQuestionIds);
            partCQuestionIds.forEach((id) => {
              if (this.questionIsAnswered(id)) removeList.push(id);
            });
          }
        }

        if (currentVersion && (currentVersion.includes(PictureCapitalV1) || currentVersion.includes(PictureCapitalV2))) {
          const idsEntities = [
            IqID.id_israeli_tax_status_3,
            IqID.id_israeli_tax_status_4,
            IqID.id_israeli_tax_status_5,
            IqID.id_israeli_tax_status_6,
            IqID.id_israeli_tax_status_7,
            IqID.id_israeli_tax_status_7_1_opt,
            IqID.id_israeli_tax_status_7_2_opt,
            IqID.id_israeli_tax_status_7_3_opt,
            IqID.id_israeli_tax_status_7_4_opt,
            IqID.id_israeli_tax_status_7_5_opt,
            IqID.id_israeli_tax_status_7,
            IqID.id_israeli_tax_status_8,
            IqID.id_israeli_tax_status_9,
            IqID.id_israeli_tax_status_9_opt,
            IqID.id_israeli_tax_status_10,
            IqID.id_israeli_tax_status_11,
            'id_israeli_tax_status_11_title',
            IqID.id_israeli_tax_status_11_1_opt,
            IqID.id_israeli_tax_status_11_2_opt,
            IqID.id_israeli_tax_status_11_3_opt,
          ];

          if (_isNaturalPerson) {
            idsEntities.forEach((idx) => {
              disabledList.push(idx);
              removeList.push(idx);
            })
          } else {
            const israeli7 = this.parseQuestionDataFromId(
              IqID.id_israeli_tax_status_7
            );
            const israeli7_1 = this.parseQuestionDataFromId(
              IqID.id_israeli_tax_status_7_1_opt
            );

            if (!israeli7 || israeli7.answer !== 'No') {
              disabledList.push(
                IqID.id_israeli_tax_status_7_1_opt,
                IqID.id_israeli_tax_status_7_2_opt,
                IqID.id_israeli_tax_status_7_3_opt,
                IqID.id_israeli_tax_status_7_4_opt,
                IqID.id_israeli_tax_status_7_5_opt
              );
              removeList.push(
                IqID.id_israeli_tax_status_7_1_opt,
                IqID.id_israeli_tax_status_7_2_opt,
                IqID.id_israeli_tax_status_7_3_opt,
                IqID.id_israeli_tax_status_7_4_opt,
                IqID.id_israeli_tax_status_7_5_opt
              );
            } else {
              const sevenAAnswered =
                israeli7_1 &&
                (israeli7_1.answer === 'Yes' || israeli7_1.answer === 'No');
              if (!sevenAAnswered) {
                disabledList.push(
                  IqID.id_israeli_tax_status_7_2_opt,
                  IqID.id_israeli_tax_status_7_3_opt,
                  IqID.id_israeli_tax_status_7_4_opt,
                  IqID.id_israeli_tax_status_7_5_opt
                );
                removeList.push(
                  IqID.id_israeli_tax_status_7_2_opt,
                  IqID.id_israeli_tax_status_7_3_opt,
                  IqID.id_israeli_tax_status_7_4_opt,
                  IqID.id_israeli_tax_status_7_5_opt
                );
              } else if (israeli7_1.answer === 'Yes') {
                disabledList.push(IqID.id_israeli_tax_status_7_2_opt);
                removeList.push(IqID.id_israeli_tax_status_7_2_opt);
              } else if (israeli7_1.answer === 'No') {
                disabledList.push(
                  IqID.id_israeli_tax_status_7_3_opt,
                  IqID.id_israeli_tax_status_7_4_opt,
                  IqID.id_israeli_tax_status_7_5_opt
                );
                removeList.push(
                  IqID.id_israeli_tax_status_7_3_opt,
                  IqID.id_israeli_tax_status_7_4_opt,
                  IqID.id_israeli_tax_status_7_5_opt
                );
              }
            }
          }

        }

        if (currentVersion && (currentVersion.includes(AltimeterV1) || currentVersion.includes(AltimeterV2) || currentVersion.includes(AltimeterPremierGrowthV1))) {
          const existingAltimeterInvestorA = this.parseQuestionDataFromId(IqID.id_existing_altimeter_8_a);
          if (!existingAltimeterInvestorA || existingAltimeterInvestorA.answer !== 'Yes') {
            disabledList.push(IqID.id_existing_altimeter_8_b);
            removeList.push(IqID.id_existing_altimeter_8_b);
            disabledList.push(IqID.id_existing_altimeter_8_d);
            removeList.push(IqID.id_existing_altimeter_8_d);
          }
        }


        const erisaA = this.parseQuestionDataFromId(
          IqID.id_special_entities_1_a
        );
        const erisaB = this.parseQuestionDataFromId(
          IqID.id_special_entities_1_b
        );
        const erisaPerc = this.parseQuestionDataFromId(
          IqID.id_special_entities_1_b_opt
        );

        const generalInfo = generalInfoJSON ? generalInfoJSON : investorFund && investorFund.generalInfo;

        if (generalInfo && currentVersion && 
           (currentVersion.includes(LimitedLiabilityCompanyV11) || 
            currentVersion.includes(LimitedLiabilityCompanyV12) ||
            currentVersion.includes(LimitedLiabilityCompanyV11_ecp) ||
            currentVersion.includes(LimitedPartnerV13) ||
            currentVersion.includes(LimitedPartnerV14) ||
            currentVersion.includes(LimitedPartnerV14_Seifdune) ||
            currentVersion.includes(SinglePictureCapitalV1) ||
            currentVersion.includes(BenchmarkV1) ||
            currentVersion.includes(DCVCV3) ||
            currentVersion.includes(TcgCrossOverCaymanV1) ||
            currentVersion.includes(LimitedPartnerV14_Nosara) ||
            currentVersion.includes(LimitedPartnerV14_Drumbeat) ||
            currentVersion.includes(LimitedPartnerV14_teamworthy) ||
            currentVersion.includes(AccelCircleV1) ||
            currentVersion.includes(AccelMainV2) ||
            currentVersion.includes(UnionPeakV1) ||
            currentVersion.includes(UnionPeakV2) ||
            currentVersion.includes(SorensonV1) ||
            currentVersion.includes(SorensonV2) ||
            currentVersion.includes(VariantV1) ||
            currentVersion.includes(VariantV2) ||
            currentVersion.includes(LPABBRV6) ||
            currentVersion.includes(LPABBRV7) ||
            currentVersion.includes(ForesiteLabsV6) ||
            currentVersion.includes(ForesiteLabsV7) ||
            currentVersion.includes(LimitedPartnershipMFV5) ||
            currentVersion.includes(LimitedPartnershipMFV6) ||
            currentVersion.includes(CaymanV6) ||
            currentVersion.includes(LimitedPartnershipMFV6_SparkCapital) ||
            currentVersion.includes(BenchmarkMultiFundV1) ||
            currentVersion.includes(PictureCapitalV1) ||
            currentVersion.includes(PictureCapitalV2) ||
            currentVersion.includes(LPMULTIFUNDV5) ||
            currentVersion.includes(LPMULTIFUNDV6)
          ) && (this.isFundCreatedAfter(FUND_VERSION.v5))) {
            const capitalCommitment =
							investorFund && generalInfo.capitalCommitment && generalInfo.capitalCommitment !== ''
								? generalInfo.capitalCommitment
								: '0';

            const capitalValue = parseFloat(capitalCommitment.toString().replaceAll(/[$,]/g, ''));

            const capitalCommitmentFund2 = investorFund && generalInfo.capitalCommitmentFund2 ? generalInfo.capitalCommitmentFund2 : '0';
            const capitalValue2 = parseFloat(capitalCommitmentFund2.toString().replaceAll(/[$,]/g, ''));

            const capitalCommitmentFund3 = investorFund && generalInfo.capitalCommitmentFund3 ? generalInfo.capitalCommitmentFund3 : '0';
            const capitalValue3 = parseFloat(capitalCommitmentFund3.toString().replaceAll(/[$,]/g, ''));

            if (currentVersion.includes(LimitedPartnershipMFV5) ||
                currentVersion.includes(LimitedPartnershipMFV6) ||
                currentVersion.includes(BenchmarkMultiFundV1) ||
                currentVersion.includes(LPMULTIFUNDV5) ||
                currentVersion.includes(LPMULTIFUNDV6) ||
                currentVersion.includes(PictureCapitalV1) ||
                currentVersion.includes(PictureCapitalV2)) {

                // Spark Capital version Capital Value is the sum of the capital values of all the investors
              if (currentVersion.includes(LimitedPartnershipMFV6_SparkCapital)) {
                const totalCapitalValue = parseFloat(capitalValue + capitalValue2 + capitalValue3);
                if (_isNaturalPerson && totalCapitalValue < 200000 && !isBlankCapitalCommitment) {
                  disabledList.push(IqID.id_investor_representations2_1);
                  removeList.push(IqID.id_investor_representations2_1);
                }
                else if (!_isNaturalPerson && totalCapitalValue < 1000000 && !isBlankCapitalCommitment) {
                  disabledList.push(IqID.id_investor_representations2_1);
                  removeList.push(IqID.id_investor_representations2_1);
                }
              } else {

                if (_isNaturalPerson && (capitalValue < 200000 && capitalValue2 < 200000 && capitalValue3 < 200000) && !isBlankCapitalCommitment) {
                  disabledList.push(IqID.id_investor_representations2_1);
                  removeList.push(IqID.id_investor_representations2_1);

                } else if (!_isNaturalPerson && (capitalValue < 1000000 && capitalValue2 < 1000000 && capitalValue3 < 1000000) && !isBlankCapitalCommitment) {
                  disabledList.push(IqID.id_investor_representations2_1);
                  removeList.push(IqID.id_investor_representations2_1);
                }
              }

            } else if (_isNaturalPerson && capitalValue < 200000 && !isBlankCapitalCommitment) {
							disabledList.push(IqID.id_investor_representations2_1);
							removeList.push(IqID.id_investor_representations2_1);
						} else if (!_isNaturalPerson && capitalValue < 1000000 && !isBlankCapitalCommitment) {
							disabledList.push(IqID.id_investor_representations2_1);
							removeList.push(IqID.id_investor_representations2_1);
						}

            const investorRepresentations9 = this.parseQuestionDataFromId(IqID.id_investor_representations_9) || {answer: 'No'};
            const investorRepresentations8 = this.parseQuestionDataFromId(IqID.id_investor_representations_8) || {answer: 'No'};
            const investorRepresentations7 = this.parseQuestionDataFromId(IqID.id_investor_representations_7) || {answer: 'No'};

            if ((investorRepresentations9 && investorRepresentations9.answer !== 'Yes') &&
              (investorRepresentations8 && investorRepresentations8.answer !== 'Yes') &&
              (investorRepresentations7 && investorRepresentations7.answer !== 'Yes')) {
                disabledList.push(IqID.id_investor_representations2_2n);
                removeList.push(IqID.id_investor_representations2_2n);
                disabledList.push(IqID.id_investor_representations2_3n);
                removeList.push(IqID.id_investor_representations2_3n);
                disabledList.push(IqID.id_investor_representations2_4n);
                removeList.push(IqID.id_investor_representations2_4n);
            }

            if (_isNaturalPerson) {
              disabledList.push(IqID.id_investor_representations2_2n);
              removeList.push(IqID.id_investor_representations2_2n);
              disabledList.push(IqID.id_investor_representations2_3n);
              removeList.push(IqID.id_investor_representations2_3n);
              disabledList.push(IqID.id_investor_representations2_4n);
              removeList.push(IqID.id_investor_representations2_4n);
            }
         }

          if (generalInfo && currentVersion && 
           (currentVersion.includes(LimitedLiabilityCompanyV13) ||
            currentVersion.includes(LimitedPartnerV15) ||
            currentVersion.includes(LPABBRV8) ||
            currentVersion.includes(LimitedPartnershipMFV7) ||
            currentVersion.includes(BenchmarkMultiFundV2) ||
            currentVersion.includes(BenchmarkMultiFundV3) ||
            currentVersion.includes(PictureCapitalV3) ||
            currentVersion.includes(LPMULTIFUNDV7) ||
            currentVersion.includes(ForesiteLabsV8) ||
            currentVersion.includes(TcgCrossOverCaymanV2) ||
            currentVersion.includes(AccelCircleV2) ||
            currentVersion.includes(SinglePictureCapitalV2) ||
            currentVersion.includes(CaymanV7) ||
            currentVersion.includes(DCVCV4) ||
            currentVersion.includes(NICFUNDV3) ||
            currentVersion.includes(VariantV3) ||
            currentVersion.includes(SorensonV3) ||
            currentVersion.includes(UnionPeakV3) ||
            currentVersion.includes(AltimeterV2) ||
            currentVersion.includes(BenchmarkV2) ||
            currentVersion.includes(BenchmarkV3)
          ) && (this.isFundCreatedAfter(FUND_VERSION.v7))) {
            const capitalCommitment =
							investorFund && generalInfo.capitalCommitment && generalInfo.capitalCommitment !== ''
								? generalInfo.capitalCommitment
								: '0';

            const capitalValue = parseFloat(capitalCommitment.toString().replaceAll(/[$,]/g, ''));

            const capitalCommitmentFund2 = investorFund && generalInfo.capitalCommitmentFund2 ? generalInfo.capitalCommitmentFund2 : '0';
            const capitalValue2 = parseFloat(capitalCommitmentFund2.toString().replaceAll(/[$,]/g, ''));

            const capitalCommitmentFund3 = investorFund && generalInfo.capitalCommitmentFund3 ? generalInfo.capitalCommitmentFund3 : '0';
            const capitalValue3 = parseFloat(capitalCommitmentFund3.toString().replaceAll(/[$,]/g, ''));

            if (currentVersion.includes(LimitedPartnershipMFV7) ||
                currentVersion.includes(BenchmarkMultiFundV2) ||
                currentVersion.includes(BenchmarkMultiFundV3) ||
                currentVersion.includes(PictureCapitalV3) ||
                currentVersion.includes(LPMULTIFUNDV7)) {

                // Spark Capital version Capital Value is the sum of the capital values of all the investors
              if (currentVersion.includes(LimitedPartnershipMFV6_SparkCapital)) {
                const totalCapitalValue = parseFloat(capitalValue + capitalValue2 + capitalValue3);
                if (_isNaturalPerson && totalCapitalValue < 200000 && !isBlankCapitalCommitment) {
                  disabledList.push(IqID.id_investor_representations2_1n);
                  removeList.push(IqID.id_investor_representations2_1n);
                }
                else if (!_isNaturalPerson && totalCapitalValue < 1000000 && !isBlankCapitalCommitment) {
                  disabledList.push(IqID.id_investor_representations2_1n);
                  removeList.push(IqID.id_investor_representations2_1n);
                }
              } else {

                if (_isNaturalPerson && (capitalValue < 200000 && capitalValue2 < 200000 && capitalValue3 < 200000) && !isBlankCapitalCommitment) {
                   disabledList.push(IqID.id_investor_representations2_1n);
                  removeList.push(IqID.id_investor_representations2_1n);

                } else if (!_isNaturalPerson && (capitalValue < 1000000 && capitalValue2 < 1000000 && capitalValue3 < 1000000) && !isBlankCapitalCommitment) {
                  disabledList.push(IqID.id_investor_representations2_1n);
                  removeList.push(IqID.id_investor_representations2_1n);
                }
              }

            } else if (_isNaturalPerson && capitalValue < 200000 && !isBlankCapitalCommitment) {
              disabledList.push(IqID.id_investor_representations2_1n);
              removeList.push(IqID.id_investor_representations2_1n);
            } else if (!_isNaturalPerson && capitalValue < 1000000 && !isBlankCapitalCommitment) {
              disabledList.push(IqID.id_investor_representations2_1n);
              removeList.push(IqID.id_investor_representations2_1n);
            }

            const investorRepresentations9 = this.parseQuestionDataFromId(IqID.id_investor_representations_9) || {answer: 'No'};
            const investorRepresentations8 = this.parseQuestionDataFromId(IqID.id_investor_representations_8) || {answer: 'No'};
            const investorRepresentations7 = this.parseQuestionDataFromId(IqID.id_investor_representations_7) || {answer: 'No'};

            if ((investorRepresentations9 && investorRepresentations9.answer !== 'Yes') &&
              (investorRepresentations8 && investorRepresentations8.answer !== 'Yes') &&
              (investorRepresentations7 && investorRepresentations7.answer !== 'Yes')) {
                disabledList.push(IqID.id_investor_representations2_2n);
                removeList.push(IqID.id_investor_representations2_2n);
                disabledList.push(IqID.id_investor_representations2_3n);
                removeList.push(IqID.id_investor_representations2_3n);
                disabledList.push(IqID.id_investor_representations2_4n);
                removeList.push(IqID.id_investor_representations2_4n);
            }

            if (_isNaturalPerson) {
              disabledList.push(IqID.id_investor_representations2_2n);
              removeList.push(IqID.id_investor_representations2_2n);
              disabledList.push(IqID.id_investor_representations2_3n);
              removeList.push(IqID.id_investor_representations2_3n);
              disabledList.push(IqID.id_investor_representations2_4n);
              removeList.push(IqID.id_investor_representations2_4n);
            }
         }

        if (currentVersion && currentVersion.includes(BitkraftIndiaV1) && _isNaturalPerson) {
            disabledList.push(IqID.idIndiaMatters_3);
            disabledList.push(IqID.idIndiaMatters_3_opt);
            removeList.push(IqID.idIndiaMatters_3);
            removeList.push(IqID.idIndiaMatters_3_opt);
        }

        if (erisaA && erisaA.answer === 'Yes' && !isAccelMain) {
          disabledList.push(IqID.id_special_entities_1_b);
          if (erisaB) {
            removeList.push(IqID.id_special_entities_1_b);
          }
          if (!erisaPerc || erisaPerc.answer !== '100') {
            valueUpdateList.push({
              id: IqID.id_special_entities_1_b_opt,
              value: '100',
            });
          }
        }

        if (erisaA && erisaA.answer === 'No') {
          if (
            (erisaPerc && erisaPerc.answer === '100') ||
            (erisaB && erisaB.answer === 'No')
          ) {
            removeList.push(IqID.id_special_entities_1_b_opt);
          }
        }
        const specialEntity9A = this.parseQuestionDataFromId(
          IqID.id_special_entities_9_a
        );

        const isSorenson = currentVersion && (currentVersion.includes(SorensonV1) || currentVersion.includes(SorensonV2) || currentVersion.includes(SorensonV3))

        if (!isSorenson && specialEntity9A && specialEntity9A.answer === 'No') {
          disabledList.push(IqID.id_special_entities_9_b);
          if (this.questionIsAnswered(IqID.id_special_entities_9_b)) {
            removeList.push(IqID.id_special_entities_9_b);
          }

          disabledList.push(IqID.id_special_entities_9_c);
          if (this.questionIsAnswered(IqID.id_special_entities_9_c)) {
            removeList.push(IqID.id_special_entities_9_c);
          }
        }
        if (_isNaturalPerson) {
          identificationofSpecialEntities.forEach((item) => {
            // this part looks odd check it better
            // already managed on cleanup method ?
            if (this.parseQuestionDataFromId(item.id)) {
              removeList.push(item.id);
            }
            disabledList.push(item.id);
            disabledList.push('special-entities-introduction-p');
            disabledList.push('special-entities-lost-descrip-quest');
          });
          disabledList.push('id_special_entities_1-title');
          disabledList.push('id_special_entities_2-title');
          disabledList.push('id_special_entities_3-title');
          disabledList.push('id_special_entities_9-title');
        }
      }
      if (wiringBankStatus) {
        const id_wiring_bank_status_1_Data = this.parseQuestionDataFromId(
          IqID.id_wiring_bank_status_1
        );
        if (
          id_wiring_bank_status_1_Data &&
          id_wiring_bank_status_1_Data.answer === 'No'
        ) {
          optionalsList.push(IqID.id_wiring_bank_status_1_opt);
        }
      }

      const cleanupListFromEntity = this.cleanupInvalidQuestions(
        _isNaturalPerson,
        _currentVersionQuestions
      );
      const _removeList = [
        ...new Set([...removeList, ...cleanupListFromEntity]),
      ];
      const _disabledList = [...new Set(disabledList)];
      const _valueUpdateList = [...new Set(valueUpdateList)];
      const _optionalsList = [...new Set(optionalsList)];

      if (_removeList.length) {
        this.removeBulkMultiSelectFormAnswer(_removeList);
      }
      this.props.setMultiSelectFormMetadata({
        disabled: _disabledList,
        valueUpdate: _valueUpdateList,
        optionals: _optionalsList,
      });
    }
  };

  updateMultiSelectFormAnswer = async (_identifier, _answer, _optionValue) => {
    const { questionnaireContext } = this.props;
    // description could be found in currentVersionQuestions or in iq.questions.array ?
    const description = '';
    const answerIdentifier = () => {
      if (_answer === 'Yes') {
        return `${_identifier}_yes`;
      }
      if (_answer === 'No') {
        return `${_identifier}_no`;
      }
      return '';
    };

    const updateData = {
      description,
      descriptionIdentifier: _identifier,
      answerIdentifier: answerIdentifier(),
      answer: _answer,
      description: _optionValue ? _optionValue : '',
    };
    if (questionnaireContext.multiAccess) {
      updateData.limitedPartnerFund = questionnaireContext.investorFund._id;
    } else {
      updateData.investorFund = questionnaireContext.investorFund._id;
    }

    try {
      const { data } = await axios.post(
        `${API_URL()}/access/questionnaire/field`,
        updateData,
        SERVICE_CONFIG_QUESTIONNAIRE()
      );
      if (data.success) {
        this.props.setInvestorFund(data.investorFund);
      } else {
        this.props.renderNotification(
          'error',
          'Error updating questionnaire field',
          data.message
        );
      }
    } catch (err) {
      this.props.logQuestionnaireError(err, this.props.questionnaireContext);
    }
  };
  updateSingleSelectFormAnswer = async (_identifier, _answer) => {
    const { questionnaireContext } = this.props;
    // description could be found in currentVersionQuestions or in iq.questions.array ?
    const description = '';
    const answerIdentifier = () => {
      if (_answer === 'Yes') {
        return `${_identifier}_yes`;
      }
      if (_answer === 'No') {
        return `${_identifier}_no`;
      }
      return '';
    };

    const updateData = {
      description,
      descriptionIdentifier: _identifier,
      answerIdentifier: answerIdentifier(),
      answer: _answer,
    };
    if (questionnaireContext.multiAccess) {
      updateData.limitedPartnerFund = questionnaireContext.investorFund._id;
    } else {
      updateData.investorFund = questionnaireContext.investorFund._id;
    }
    try {
      const { data } = await axios.post(
        `${API_URL()}/access/questionnaire/field`,
        updateData,
        SERVICE_CONFIG_QUESTIONNAIRE()
      );
      if (data.success) {
        this.props.setInvestorFund(data.investorFund);
      } else {
        this.props.renderNotification(
          'error',
          'Error updating questionnaire field',
          data.message
        );
      }
    } catch (err) {
      this.props.logQuestionnaireError(err, this.props.questionnaireContext);
    }
  };

  removeMultiSelectFormAnswer = async (
    _identifier,
    _questionnaireIdentifier
  ) => {
    try {
      const { data } = await axios.post(
        `${API_URL()}/access/questionnaire/field/remove`,
        {
          descriptionIdentifier: _identifier,
          questionnaire: _questionnaireIdentifier,
        },
        SERVICE_CONFIG_QUESTIONNAIRE()
      );
      if (data.success) {
        this.props.setInvestorFund(data.investorFund);
      } else {
        this.props.renderNotification(
          'error',
          'Error removing questionnaire field',
          data.message
        );
      }
    } catch (err) {
      this.props.logQuestionnaireError(err, this.props.questionnaireContext);
    }
  };
  removeBulkMultiSelectFormAnswer = async (_identifierList) => {
    const { questionnaireContext } = this.props;
    try {
      const signatureTab = window.location.href.includes('signatures');
      if (!signatureTab) {
        const { data } = await axios.post(
          `${API_URL()}/access/questionnaire/fields/remove`,
          {
            fields: _identifierList,
            questionnaire: questionnaireContext.investorFund.questionnaire._id,
          },
          SERVICE_CONFIG_QUESTIONNAIRE()
        );

        if (data.success) {
          this.props.setInvestorFund(data.investorFund);
          // dispatch removing ???????
        } else {
          this.props.renderNotification(
            'error',
            'Error removing bulk questionnaire fields',
            data.message
          );
        }
      }
    } catch (err) {
      this.props.logQuestionnaireError(err, this.props.questionnaireContext);
    }
  };

  triggerNextStep = (e) => {
    const targetContainerId = e.target.getAttribute('data-position');
    const nextStep = Number(targetContainerId.split('step-')[1]);
    this.handleStepRedirect(e, nextStep);
  };
  nextStep = (e) => {
    const { questionnaireContext } = this.props;
    this.handleStepRedirect(e, questionnaireContext.currentStep + 1);
  };
  saveStepStorageInformation = (followingStep) => {
    // need to check why on FlowHome general information was getting saved along saving this data most likely to save the sessionStorage generalInformation present, looks like it happen only when the last step was the general information
    sessionStorage.setItem(iq_last_step_token, followingStep);
  };
  sessionStorageCleanup = async () => {
    const res = await axios.post(
      `${API_URL()}/access/leaveQuestionnaire`,
      {
        iq: sessionStorage.getItem(iq_cb_token),
        user: sessionStorage.getItem(iq_cb_user_token),
      },
      SERVICE_CONFIG_QUESTIONNAIRE()
    );
    sessionStorage.removeItem(iq_last_step_token);
    sessionStorage.removeItem(iq_cb_token);
    sessionStorage.removeItem(iq_cb_user_token);
    sessionStorage.removeItem(iq_general_info_token);
  };
  leaveQuestionnaire = (e) => {
    e.preventDefault();
    // FIXME need to save all related Progress here
    // generalInfo and Questionnaire
    const { questionnaireContext, history } = this.props;
    // eslint-disable-next-line
    if (window.confirm('Are you sure you want to leave the Questionnaire ?')) {
      this.sessionStorageCleanup();
      history.push(`/access/login?f=${questionnaireContext.fund._id}`);
      this.closeButton.click();
    }
  };

  handleIQAccessExpiration = () => {
    const { questionnaireContext, history } = this.props;
    this.props.isQuestionnaireExpired(false);
    this.sessionStorageCleanup();
    history.push(`/access/login?f=${questionnaireContext.fund._id}`);
  };

  saveGeneralInformation = async (_payload) => {
    this.props.setSavingInfo(true);
    try {
      const res = await axios.post(
        `${API_URL()}/access/generalInfo`,
        _payload,
        SERVICE_CONFIG_QUESTIONNAIRE()
      );
      if (res.data.success) {
        this.props.setInvestorFund(res.data.investorFund);
        this.props.setSavingInfo(false);
        this.fetchInvestorInfo();
      }
    } catch (err) {
      this.props.setSavingInfo(false);
      this.props.logQuestionnaireError(err, this.props.questionnaireContext);
    }
  };

  handleStepRedirect = async (event, nextStep) => {
    const { history, questionnaireContext } = this.props;
    const currentIQVersion = questionnaireContext.investorFund && 
      questionnaireContext.investorFund.questionnaire &&
      questionnaireContext.investorFund.questionnaire.iqVersion;
    const terrariumSubscribedPerson = questionnaireContext && questionnaireContext.investorFund && questionnaireContext.investorFund.generalInfo && 
      questionnaireContext.investorFund.generalInfo.terrariumSubscribedPerson ? questionnaireContext.investorFund.generalInfo.terrariumSubscribedPerson : null;

    event.preventDefault();
    this.props.setCurrentStep(nextStep);
    this.saveStepStorageInformation(nextStep);
    
    this.saveGeneralInformation(
      JSON.parse(sessionStorage.getItem('generalInfo'))
    );

    if (nextStep !== 3) {
      if (questionnaireContext.signaturesMethod !== '') {
        this.props.setSignaturesMethod('');
      }
    }
    if (currentIQVersion.includes(AccelV1) || 
        currentIQVersion.includes(AccelV2) || 
        currentIQVersion.includes(AccelV3) ||
        currentIQVersion.includes(AccelV4)) {
      switch (nextStep) {
      case 0:
        history.push('/access/home/instructions');
        break;
      case 1:
        history.push('/access/home/letter');
        break;
      case 2:
        history.push('/access/home/information');
        break;
      case 3:
        history.push('/access/home/questionnaire');
        break;
      case 4:
        await confirmDocCanBeSigned(this.props);
        history.push('/access/home/signatures');
        break;
      default:
        history.push('/access/home/instructions');
        break;
      }
    }
    else if (currentIQVersion.includes(VariantV1) || currentIQVersion.includes(VariantV2) || currentIQVersion.includes(VariantV3)) {
      switch (nextStep) {
        case 0:
          history.push('/access/home/instructions');
          break;
        case 1:
          history.push('/access/home/information');
          break;
        case 2:
          history.push('/access/home/questionnaire');
          break;
        case 3:
          history.push('/access/home/distribution');
          break;
        case 4:
          await confirmDocCanBeSigned(this.props);
          history.push('/access/home/signatures');
          break;
        default:
          history.push('/access/home/instructions');
          break;
      }
    }
    else if (currentIQVersion.includes(UnionPeakV1) || currentIQVersion.includes(UnionPeakV2) || currentIQVersion.includes(UnionPeakV3)) {
      switch (nextStep) {
        case 0:
          history.push('/access/home/instructions');
          break;
        case 1:
          history.push('/access/home/information');
          break;
        case 2:
          history.push('/access/home/questionnaire');
          break;
        case 3:
          history.push('/access/home/dissolution');
          break;
        case 4:
          await confirmDocCanBeSigned(this.props);
          history.push('/access/home/signatures');
          break;
        default:
          history.push('/access/home/instructions');
          break;
      }
    }
    else if (currentIQVersion.includes(AltimeterAMLV1)) {
      switch (nextStep) {
      case 0:
        history.push('/access/home/questionnaire');
        break;
      case 1:
        history.push('/access/home/signatures');
        try {
          // TODO:
          await confirmAltimeterAMLDocCanBeSigned(this.props);
        } catch (err) {
          this.props.logQuestionnaireError(err, questionnaireContext);
        }
        break;
      default:
        history.push('/access/home/questionnaire');
        break;
      }
    }
    else if (currentIQVersion.includes(AccelEtpnReturningV1) || 
        currentIQVersion.includes(AccelEtpnReturningV2) ||
        currentIQVersion.includes(AccelEtpnReturningMultiV1)) {
        switch (nextStep) {
          case 0:
            history.push('/access/home/information');
          break;
          case 1:
            confirmReturningInvestorCanSign(this.props);
            history.push('/access/home/signatures');
            break;
          default:
            history.push('/access/home/information');
            break;
        }
    } else if (currentIQVersion.includes(TerrariumV1)) {
      if (terrariumSubscribedPerson === 'yes') {
        switch (nextStep) {
          case 0:
            history.push('/access/home/information');
          break;
          case 1:
            confirmReturningInvestorCanSign(this.props);
            history.push('/access/home/signatures');
            break;
          default:
            history.push('/access/home/information');
            break;
        }
      } else {
        switch (nextStep) {
          case 0:
            history.push('/access/home/instructions');
            break;
          case 1:
            history.push('/access/home/information');
            break;
          case 2:
            history.push('/access/home/questionnaire');
            break;
          case 3:
            await confirmDocCanBeSigned(this.props);
            history.push('/access/home/signatures');
            break;
          default:
           history.push('/access/home/information');
            break;
         }
      }
    } else {
      switch (nextStep) {
      case 0:
        history.push('/access/home/instructions');
        break;
      case 1:
        history.push('/access/home/information');
        break;
      case 2:
        history.push('/access/home/questionnaire');
        break;
      case 3:
        await confirmDocCanBeSigned(this.props);
        history.push('/access/home/signatures');
        break;
      default:
        history.push('/access/home/instructions');
        break;
      }
    }
    
    window.scrollTo(0, 0);
  };

  accessHomeRoutes = () => {
    const { questionnaireContext } = this.props;
    let IQ_VERSION =
      questionnaireContext.investorFund &&
      questionnaireContext.investorFund.questionnaire &&
      questionnaireContext.investorFund.questionnaire.iqVersion;

    const terrariumSubscribedPerson = questionnaireContext && questionnaireContext.investorFund && questionnaireContext.investorFund.generalInfo && 
      questionnaireContext.investorFund.generalInfo.terrariumSubscribedPerson ? questionnaireContext.investorFund.generalInfo.terrariumSubscribedPerson : null;
    
    if (!IQ_VERSION) {
      IQ_VERSION = LimitedPartnerV1;
    }
    const commonProps = {
      handleRedirect: this.handleStepRedirect,
      logQuestionnaireError: this.props.logQuestionnaireError,
      setFund: this.props.setFund,
      setInvestor: this.props.setInvestor,
      setInvestorFund: this.props.setInvestorFund,
      setCurrentStep: this.props.setCurrentStep,
      isQuestionnaireExpired: this.props.isQuestionnaireExpired,
      setSavingInfo: this.props.setSavingInfo,
      setGeneralInformationTrigger: this.props.setGeneralInformationTrigger,
      isSignaturesEnabled: this.props.isSignaturesEnabled,
      setValidationRequiredParts: this.props.setValidationRequiredParts,
      showSignaturesInstructions: this.props.showSignaturesInstructions,
      renderNotification: this.props.renderNotification,
    };
    let IQ_current_version = null;
    let INSTRUCTIONS_current_version = null;
    let GENERAL_INFO_current_version = null;
    let INTEREST_LETTER_current_version = null;
    let INTEREST_DISTRIBUTION_current_version = null;
    let CONSENT_TO_DISSOLUTION_current_version = null;
    switch (IQ_VERSION) {
      case LimitedPartnerV1:
        IQ_current_version = (
          <QuestionnairePageLPv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLP
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case LimitedPartnerV2:
        IQ_current_version = (
          <QuestionnairePageLPv2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLP
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case LimitedPartnerV3:
        IQ_current_version = (
          <QuestionnairePageLPv3
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLP
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case LimitedPartnerV4:
        IQ_current_version = (
          <QuestionnairePageLPv4
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPv4
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case LimitedPartnerV5:
        IQ_current_version = (
          <QuestionnairePageLPv5
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPv5
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      case LimitedPartnerV6:
        IQ_current_version = (
          <QuestionnairePageLPv6
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPv6
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      case LimitedPartnerV7:
        IQ_current_version = (
          <QuestionnairePageLPv7
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPv7
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      case LimitedPartnerV8:
        IQ_current_version = (
          <QuestionnairePageLPv8
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPv8
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      case LimitedPartnerV8_1:
        IQ_current_version = (
          <QuestionnairePageLPv8_1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPv8_1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      case LimitedPartnerV9:
        IQ_current_version = (
          <QuestionnairePageLPv9
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPv9
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
      case LimitedPartnerV10:
      case LimitedPartnerV10_1:
        IQ_current_version = (
          <QuestionnairePageLPv10
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPv10
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
        
      case LimitedPartnerV11:
        IQ_current_version = (
          <QuestionnairePageLPv11
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPv11
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case LimitedPartnerV12:
        IQ_current_version = (
          <QuestionnairePageLPv12
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPv12
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break; 

      case LimitedPartnerV13:
      case LimitedPartnerV14:
      case LimitedPartnerV14_Drumbeat:
        IQ_current_version = (
          <QuestionnairePageLPv13
          {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPv13
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
      break; 

      case LimitedPartnerV15:
        IQ_current_version = (
          <QuestionnairePageLPv15
          {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPv15
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case LimitedPartnerV14_teamworthy:
        IQ_current_version = (
          <QuestionnairePageLPv14Teamworthy
          {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPv14Teamworthy
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
      case LimitedPartnerV14_Nosara:
        IQ_current_version = (
          <QuestionnairePageLPv14Nosara
          {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPv14Nosara
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
      break; 

      case LimitedPartnerV14_Seifdune:
        IQ_current_version = (
          <QuestionnairePageLPv14Seifdune
          {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPv14Seifdune
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
      break; 

      case SinglePictureCapitalV1:
        IQ_current_version = (
          <QuestionnairePageSinglePictureCapitalv1
          {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageSinglePictureCapital {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageSinglePictureCapitalv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case SinglePictureCapitalV2:
        IQ_current_version = (
          <QuestionnairePageSinglePictureCapitalv2
          {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageSinglePictureCapital {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageSinglePictureCapitalv2
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
      case AltimeterV1:
        IQ_current_version = (
          <QuestionnairePageAltimeterv1
          {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsAltimeter {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageAltimeterv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case AltimeterV2:
        IQ_current_version = (
          <QuestionnairePageAltimeterv2
          {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsAltimeter {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageAltimeterv2
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case AltimeterPremierGrowthV1:
        IQ_current_version = (
          <QuestionnairePageAltimeterPremierGrowthv1
          {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsAltimeterPremierGrowth {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageAltimeterPremierGrowthv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case AltimeterAMLV1:
        IQ_current_version = (
          <QuestionnairePageAltimeterAMLv1
          {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsAltimeterAML {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageAltimeterAMLv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case BenchmarkV1:
        IQ_current_version = (
          <QuestionnairePageBenchmarkv1
          {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageBenchmark {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageBenchmarkv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );  
        break;

      case BenchmarkV2:
        IQ_current_version = (
          <QuestionnairePageBenchmarkv2
          {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageBenchmark {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageBenchmarkv2
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );  
        break;

      case BenchmarkV3:
        IQ_current_version = (
          <QuestionnairePageBenchmarkv3
          {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageBenchmark {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageBenchmarkv3
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case UnionPeakV1:
      case UnionPeakV2:
        IQ_current_version = (
          <QuestionnairePageUnionPeakv1
          {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        CONSENT_TO_DISSOLUTION_current_version = ( 
          <DissolutionForm 
            context={this.props.context}
            questionnaireContext={this.props.questionnaireContext}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
            {...commonProps} />
          );
        INSTRUCTIONS_current_version = <InstructionsPageUnionPeak {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageUnionPeakv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
      break;

      case UnionPeakV3:
        IQ_current_version = (
          <QuestionnairePageUnionPeakv3
          {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        CONSENT_TO_DISSOLUTION_current_version = ( 
          <DissolutionFormV3 
            context={this.props.context}
            questionnaireContext={this.props.questionnaireContext}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
            {...commonProps} />
          );
        INSTRUCTIONS_current_version = <InstructionsPageUnionPeak {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageUnionPeakv3
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
      break;

      case SorensonV1:
      case SorensonV2:
        IQ_current_version = (
          <QuestionnairePageSorensonv1
          {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageSorenson {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageSorensonv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
      break;

      case SorensonV3:
        IQ_current_version = (
          <QuestionnairePageSorensonv3
          {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageSorenson {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageSorensonv3
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
      break;

      case VariantV1:
      case VariantV2:
        IQ_current_version = (
          <QuestionnairePageVariantv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );

        INTEREST_DISTRIBUTION_current_version = (
          <DistributionForm
            context={this.props.context}
            questionnaireContext={this.props.questionnaireContext}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
            {...commonProps}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageVariant {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageVariantv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
      break; 

      case VariantV3:
        IQ_current_version = (
          <QuestionnairePageVariantv3
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );

        INTEREST_DISTRIBUTION_current_version = (
          <DistributionFormV3
            context={this.props.context}
            questionnaireContext={this.props.questionnaireContext}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
            {...commonProps}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageVariant {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageVariantv3
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
      break; 
          
      case OCMV1:
      case OCMV2:
        IQ_current_version = (
          <QuestionnairePageOCMv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
      
        INSTRUCTIONS_current_version = <InstructionsPageOCM {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageOCMv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break; 

      case DCVCV1:
      case DCVCV2:
        IQ_current_version = (
          <QuestionnairePageDCVCv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageDCVC {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageDCVCv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break; 

      case DCVCV3:
        IQ_current_version = (
          <QuestionnairePageDCVCv3
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageDCVC {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageDCVCv3
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case DCVCV4:
        IQ_current_version = (
          <QuestionnairePageDCVCv4
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageDCVC {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageDCVCv4
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case FrazierV1:
        IQ_current_version = (
          <QuestionnairePageFrazierv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageFrazier {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLFrazierv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break; 

       case FrazierV2:
       case FrazierV3:
        IQ_current_version = (
          <QuestionnairePageFrazierv2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageFrazier {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLFrazierv2
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break; 
      
      case QuestaCapitalV1:
      case QuestaCapitalV2:
        IQ_current_version = (
          <QuestionnairePageQuestaCapitalv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageQuestaCapital {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageQuestaCapital
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case QuestaCapitalV2:
        IQ_current_version = (
          <QuestionnairePageQuestaCapitalv2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageQuestaCapital {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageQuestaCapital
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case QuestaCapitalV3:
        IQ_current_version = (
          <QuestionnairePageQuestaCapitalv3
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageQuestaCapital {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageQuestaCapitalv3
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case QuestaCapitalV4:
        IQ_current_version = (
          <QuestionnairePageQuestaCapitalv4
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageQuestaCapital {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageQuestaCapitalv4
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      case QuestaCapitalV5:
        IQ_current_version = (
          <QuestionnairePageQuestaCapitalv5
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageQuestaCapital {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageQuestaCapitalv5
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      case QuestaCapitalV6:
        IQ_current_version = (
          <QuestionnairePageQuestaCapitalv6
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageQuestaCapital {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageQuestaCapitalv6
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      case QuestaCapitalV7:
        IQ_current_version = (
          <QuestionnairePageQuestaCapitalv7
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageQuestaCapital {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageQuestaCapitalv7
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
      case QuestaCapitalV8:
      case QuestaCapitalV9:
        IQ_current_version = (
          <QuestionnairePageQuestaCapitalv8
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageQuestaCapital {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageQuestaCapitalv8
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;


      case LimitedLiabilityCompanyV1:
        IQ_current_version = (
          <QuestionnairePageLLCv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLLC {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLLC
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case LimitedLiabilityCompanyV2:
        IQ_current_version = (
          <QuestionnairePageLLCv2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLLC {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLLC
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case LimitedLiabilityCompanyV3:
        IQ_current_version = (
          <QuestionnairePageLLCv3
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLLC {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLLCv3
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case LimitedLiabilityCompanyV4:
        IQ_current_version = (
          <QuestionnairePageLLCv4
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLLC {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLLCv4
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      case LimitedLiabilityCompanyV5:
        IQ_current_version = (
          <QuestionnairePageLLCv5
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLLC {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLLCv5
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      case LimitedLiabilityCompanyV6:
        IQ_current_version = (
          <QuestionnairePageLLCv6
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLLC {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLLCv6
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      case LimitedLiabilityCompanyV6_1:
        IQ_current_version = (
          <QuestionnairePageLLCv6_1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLLC {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLLCv6_1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      case LimitedLiabilityCompanyV7:
        IQ_current_version = (
          <QuestionnairePageLLCv7
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLLC {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLLCv7
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
      case LimitedLiabilityCompanyV8:
      case LimitedLiabilityCompanyV8_1:
        IQ_current_version = (
          <QuestionnairePageLLCv8
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLLC {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLLCv8
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case LimitedLiabilityCompanyV9:
        IQ_current_version = (
          <QuestionnairePageLLCv9
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLLC {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLLCv9
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case LimitedLiabilityCompanyV10:
        IQ_current_version = (
          <QuestionnairePageLLCv10
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLLC {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLLCv10
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case LimitedLiabilityCompanyV11:
      case LimitedLiabilityCompanyV12:
      case LimitedLiabilityCompanyV11_ecp:
        IQ_current_version = (
          <QuestionnairePageLLCv11
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLLC {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLLCv11
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case LimitedLiabilityCompanyV13:
        IQ_current_version = (
          <QuestionnairePageLLCv13
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLLC {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLLCv13
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
      case ForesiteV1:
        IQ_current_version = (
          <QuestionnairePageForesitev1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageForesite {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageForesite
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case ForesiteV2:
        IQ_current_version = (
          <QuestionnairePageForesitev2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageForesite {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageForesite
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case ForesiteV3:
        IQ_current_version = (
          <QuestionnairePageForesitev3
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageForesite {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageForesitev3
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case ForesiteV4:
        IQ_current_version = (
          <QuestionnairePageForesitev4
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageForesite {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageForesitev4
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case ForesiteV5:
        IQ_current_version = (
          <QuestionnairePageForesitev5
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageForesite {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageForesitev5
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      case ForesiteV6:
        IQ_current_version = (
          <QuestionnairePageForesitev6
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageForesite {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageForesitev6
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
      case ForesiteV7:
        IQ_current_version = (
          <QuestionnairePageForesitev7
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageForesite {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageForesitev7
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
      case ForesiteV8:
      case ForesiteV9:
        IQ_current_version = (
          <QuestionnairePageForesitev8
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageForesite {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageForesitev8
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
      case InitializedV1:
        IQ_current_version = (
          <QuestionnairePageInitializedv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageInitialized {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageInitialized
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case InitializedV2:
        IQ_current_version = (
          <QuestionnairePageInitializedv2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageInitialized {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageInitialized
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case InitializedV3:
        IQ_current_version = (
          <QuestionnairePageInitializedv3
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageInitialized {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageInitializedV3
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case InitializedV4:
        IQ_current_version = (
          <QuestionnairePageInitializedv4
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageInitialized {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageInitializedV4
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      case InitializedV5:
        IQ_current_version = (
          <QuestionnairePageInitializedv5
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageInitialized {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageInitializedV5
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case InitializedV6:
        IQ_current_version = (
          <QuestionnairePageInitializedv6
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageInitialized {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageInitializedV6
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
      case InitializedV7:
        IQ_current_version = (
          <QuestionnairePageInitializedv7
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageInitialized {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageInitializedV7
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case InitializedV8:
      case InitializedV9:
        IQ_current_version = (
          <QuestionnairePageInitializedv8
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageInitialized {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageInitializedV8
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
      case HCMV1:
        IQ_current_version = (
          <QuestionnairePageHCMv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            removeBulkMultiSelectFormAnswer={
              this.removeBulkMultiSelectFormAnswer
            }
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageHCM {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageHCMv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case HCMV2:
        IQ_current_version = (
          <QuestionnairePageHCMv2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            removeBulkMultiSelectFormAnswer={
              this.removeBulkMultiSelectFormAnswer
            }
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageHCM {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageHCMv2
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case HCMV3:
        IQ_current_version = (
          <QuestionnairePageHCMv3
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            removeBulkMultiSelectFormAnswer={
              this.removeBulkMultiSelectFormAnswer
            }
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageHCM {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageHCMv3
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
      case HCMV4:
        IQ_current_version = (
          <QuestionnairePageHCMv4
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            removeBulkMultiSelectFormAnswer={
              this.removeBulkMultiSelectFormAnswer
            }
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageHCM {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageHCMv4
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
      case HCMV5:
      case HCMV6:
        IQ_current_version = (
          <QuestionnairePageHCMv5
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            removeBulkMultiSelectFormAnswer={
              this.removeBulkMultiSelectFormAnswer
            }
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageHCM {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageHCMv5
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case ForesiteLabsV1:
        IQ_current_version = (
          <QuestionnairePageForesiteLabsv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            removeBulkMultiSelectFormAnswer={
              this.removeBulkMultiSelectFormAnswer
            }
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageForesiteLabs {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageForesiteLabsv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      case ForesiteLabsV2:
        IQ_current_version = (
          <QuestionnairePageForesiteLabsv2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            removeBulkMultiSelectFormAnswer={
              this.removeBulkMultiSelectFormAnswer
            }
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageForesiteLabs {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageForesiteLabsv2
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      case ForesiteLabsV3:
        IQ_current_version = (
          <QuestionnairePageForesiteLabsv3
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            removeBulkMultiSelectFormAnswer={
              this.removeBulkMultiSelectFormAnswer
            }
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageForesiteLabs {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageForesiteLabsv3
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case ForesiteLabsV4:
        IQ_current_version = (
          <QuestionnairePageForesiteLabsv4
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            removeBulkMultiSelectFormAnswer={
              this.removeBulkMultiSelectFormAnswer
            }
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageForesiteLabs {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageForesiteLabsv4
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case ForesiteLabsV5:
        IQ_current_version = (
          <QuestionnairePageForesiteLabsv5
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            removeBulkMultiSelectFormAnswer={
              this.removeBulkMultiSelectFormAnswer
            }
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageForesiteLabs {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageForesiteLabsv5
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
      case ForesiteLabsV6:
      case ForesiteLabsV7:
        IQ_current_version = (
          <QuestionnairePageForesiteLabsv6
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            removeBulkMultiSelectFormAnswer={
              this.removeBulkMultiSelectFormAnswer
            }
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageForesiteLabs {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageForesiteLabsv6
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case ForesiteLabsV8:
        IQ_current_version = (
          <QuestionnairePageForesiteLabsv8
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            removeBulkMultiSelectFormAnswer={
              this.removeBulkMultiSelectFormAnswer
            }
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = (
          <InstructionsPageForesiteLabs {...commonProps} />
        );
        GENERAL_INFO_current_version = (
          <GeneralInfoPageForesiteLabsv8
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case LPABBRV1:
        IQ_current_version = (
          <QuestionnairePageLPAbbrv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPAbbrv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

        case LPABBRV1_1:
        IQ_current_version = (
          <QuestionnairePageLPAbbrv1_1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPAbbrv1_1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
      case LPABBRV2:
        IQ_current_version = (
          <QuestionnairePageLPAbbrv2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPAbbrv2
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case LPABBRV3_1:
      case LPABBRV3:
        IQ_current_version = (
          <QuestionnairePageLPAbbrv3
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPAbbrv3
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
      case LPABBRV4:
        IQ_current_version = (
          <QuestionnairePageLPAbbrv4
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPAbbrv4
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case LPABBRV5:
        IQ_current_version = (
          <QuestionnairePageLPAbbrv5
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPAbbrv5
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case LPABBRV6:
      case LPABBRV7:
        IQ_current_version = (
          <QuestionnairePageLPAbbrv6
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPAbbrv6
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case LPABBRV8:
        IQ_current_version = (
          <QuestionnairePageLPAbbrv8
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPAbbrv8
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
      case IOLARV1:
        IQ_current_version = (
          <QuestionnairePageIolarv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageIolar {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageIolarv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

       case IOLARV2:
        IQ_current_version = (
          <QuestionnairePageIolarv2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageIolar {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageIolarv2
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

        case IOLARV3:
        case IOLARV4:
          IQ_current_version = (
            <QuestionnairePageIolarv3
              {...commonProps}
              updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
              history={this.props.history}
            />
          );
          INSTRUCTIONS_current_version = <InstructionsPageIolar {...commonProps} />;
          GENERAL_INFO_current_version = (
            <GeneralInfoPageIolarv3
              updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
              {...commonProps}
            />
          );
        break;

      case OSAGEV1:
        IQ_current_version = (
          <QuestionnairePageOSAGEv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageOSAGEv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case OSAGEV2:
        IQ_current_version = (
          <QuestionnairePageOSAGEv2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageOSAGEv2
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case OSAGEV3:
      case OSAGEV4:
        IQ_current_version = (
          <QuestionnairePageOSAGEv3
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageOSAGEv3
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case NewLimitedPartnerV1:
        IQ_current_version = (
          <QuestionnairePageNewLimitedPartnerv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageNewLimitedPartnerv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
      case NewLimitedPartnerV2:
        IQ_current_version = (
          <QuestionnairePageNewLimitedPartnerv2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageNewLimitedPartnerv2
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case NewLimitedPartnerV3:
      case NewLimitedPartnerV4:
        IQ_current_version = (
          <QuestionnairePageNewLimitedPartnerv3
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageNewLimitedPartnerv3
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
      case TcgCrossOverV1:
        IQ_current_version = (
          <QuestionnairePageTcgCrossOverv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageTcgCrossOver {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageTcgCrossOverv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case TcgCrossOverV2:
        IQ_current_version = (
          <QuestionnairePageTcgCrossOverv2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageTcgCrossOver {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageTcgCrossOverv2
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case TcgCrossOverV3:
      case TcgCrossOverV4:
        IQ_current_version = (
          <QuestionnairePageTcgCrossOverv3
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageTcgCrossOver {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageTcgCrossOverv3
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case TcgCrossOverCaymanV1:
        IQ_current_version = (
          <QuestionnairePageTcgCrossOverCaymanv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            history={this.props.history}
          />
        );
      
        INSTRUCTIONS_current_version = <InstructionsPageTcgCrossOverCayman {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageTcgCrossOverCaymanv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case TcgCrossOverCaymanV2:
        IQ_current_version = (
          <QuestionnairePageTcgCrossOverCaymanv2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            history={this.props.history}
          />
        );
      
        INSTRUCTIONS_current_version = <InstructionsPageTcgCrossOverCayman {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageTcgCrossOverCaymanv2
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case BITKRAFTV1:
        IQ_current_version = (
          <QuestionnairePageBitKraftv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageBitKraft {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageBitKraftv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
      case BITKRAFTV2:
        IQ_current_version = (
          <QuestionnairePageBitKraftv2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageBitKraft {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageBitKraftv2
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case BITKRAFTV3:
      case BITKRAFTV4:
        IQ_current_version = (
          <QuestionnairePageBitKraftv3
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageBitKraft {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageBitKraftv3
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case BitkraftIndiaV1:
      case BitkraftIndiaV2:
        IQ_current_version = (
          <QuestionnairePageBitKraftIndiav1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageBitKraftIndia {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageBitKraftIndiav1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
      case CaymanV1:
        IQ_current_version = (
          <QuestionnairePageCaymanv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageCayman {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageCaymanv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case CaymanV2:
        IQ_current_version = (
          <QuestionnairePageCaymanv2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageCayman {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageCaymanv2
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case CaymanV3:
        IQ_current_version = (
          <QuestionnairePageCaymanv3
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageCaymanv3 {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageCaymanv3
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
      case CaymanV4:
      case CaymanV5:
        IQ_current_version = (
          <QuestionnairePageCaymanv4
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageCaymanv4 {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageCaymanv4
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case CaymanV6:
        IQ_current_version = (
          <QuestionnairePageCaymanv6
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageCaymanv6 {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageCaymanv6
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case CaymanV7:
        IQ_current_version = (
          <QuestionnairePageCaymanv7
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageCaymanv7 {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageCaymanv7
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case ElephantPartnerV1:
        IQ_current_version = (
          <QuestionnairePageElephantPartnerv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageElephantPartner {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageElephantPartnerv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
       case ElephantPartnerV2:
        IQ_current_version = (
          <QuestionnairePageElephantPartnerv2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageElephantPartner {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageElephantPartnerv2
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case ElephantPartnerV3:
      case ElephantPartnerV4:
        IQ_current_version = (
          <QuestionnairePageElephantPartnerv3
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            updateSingleSelectFormAnswer={this.updateSingleSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageElephantPartner {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageElephantPartnerv3
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case FireworkV1:
        IQ_current_version = (
          <QuestionnairePageFireworkv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageFireworkv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

        case FireworkV2:
          IQ_current_version = (
            <QuestionnairePageFireworkv2
              {...commonProps}
              updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
              history={this.props.history}
            />
          );
          INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
          GENERAL_INFO_current_version = (
            <GeneralInfoPageFireworkv2
              updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
              {...commonProps}
            />
          );
        break;

        case FireworkV3:
        case FireworkV4:  
          IQ_current_version = (
            <QuestionnairePageFireworkv3
              {...commonProps}
              updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
              history={this.props.history}
            />
          );
          INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
          GENERAL_INFO_current_version = (
            <GeneralInfoPageFireworkv3
              updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
              {...commonProps}
            />
          );
        break;

        case PrometheanV1:
        IQ_current_version = (
          <QuestionnairePrometheanv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPagePrometheanv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

       case PrometheanV2:
        IQ_current_version = (
          <QuestionnairePrometheanv2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPagePrometheanv2
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

        case PrometheanV3:
        case PrometheanV4:
        IQ_current_version = (
          <QuestionnairePrometheanv3
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageLP {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPagePrometheanv3
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case AccelV1:
        IQ_current_version = (
          <QuestionnairePageAccelv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INTEREST_LETTER_current_version = (
        <InterestLetterPageAccelv1
         updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps} 
          />
        );

        INSTRUCTIONS_current_version = <InstructionsPageAccel {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageAccelv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case AccelV2:
        IQ_current_version = (
          <QuestionnairePageAccelv2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INTEREST_LETTER_current_version = (
        <InterestLetterPageAccelv2
         updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps} 
          />
        );

        INSTRUCTIONS_current_version = <InstructionsPageAccel {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageAccelv2
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
      case AccelV3:
        IQ_current_version = (
          <QuestionnairePageAccelv3
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INTEREST_LETTER_current_version = (
        <InterestLetterPageAccelv3
         updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps} 
          />
        );

        INSTRUCTIONS_current_version = <InstructionsPageAccel {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageAccelv3
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case AccelV4:
        IQ_current_version = (
          <QuestionnairePageAccelv4
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INTEREST_LETTER_current_version = (
        <InterestLetterPageAccelv4
         updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps} 
          />
        );

        INSTRUCTIONS_current_version = <InstructionsPageAccel {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageAccelv4
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case AccelMainV1:
        IQ_current_version = (
          <QuestionnairePageAccelMainv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageAccelMain {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageAccelMainv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case AccelMainV2:
      case AccelMainV3:
        IQ_current_version = (
          <QuestionnairePageAccelMainv2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageAccelMain {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageAccelMainv2
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case AccelEntrepreneursV1:
        IQ_current_version = (
          <QuestionnairePageAccelEntrepreneursv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageAccelEntrepreneurs {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageAccelEntrepreneursv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

        case AccelEntrepreneursV2:
          IQ_current_version = (
            <QuestionnairePageAccelEntrepreneursv2
              {...commonProps}
              updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
              history={this.props.history}
            />
          );
          INSTRUCTIONS_current_version = <InstructionsPageAccelEntrepreneurs {...commonProps} />;
          GENERAL_INFO_current_version = (
            <GeneralInfoPageAccelEntrepreneursv2
              updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
              {...commonProps}
            />
          );
        break;

      case AccelCircleV1:
          IQ_current_version = (
            <QuestionnairePageAccelCirclev1
              {...commonProps}
              updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
              history={this.props.history}
            />
          );
          INSTRUCTIONS_current_version = <InstructionsPageAccelCirclev1 {...commonProps} />;
          GENERAL_INFO_current_version = (
            <GeneralInfoPageAccelCirclev1
              updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
              {...commonProps}
            />
          );
        break;

      case AccelCircleV2:
          IQ_current_version = (
            <QuestionnairePageAccelCirclev2
              {...commonProps}
              updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
              history={this.props.history}
            />
          );
          INSTRUCTIONS_current_version = <InstructionsPageAccelCirclev2 {...commonProps} />;
          GENERAL_INFO_current_version = (
            <GeneralInfoPageAccelCirclev2
              updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
              {...commonProps}
            />
          );
        break;

      case AccelEtpnReturningV1:
        IQ_current_version = <div>none</div>
        INSTRUCTIONS_current_version = (
          <GeneralInfoPageAccelEtpnReturningv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />);
        GENERAL_INFO_current_version = (
          <GeneralInfoPageAccelEtpnReturningv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        break;

      case AccelEtpnReturningV2:
        IQ_current_version = <div>none</div>
        INSTRUCTIONS_current_version = (
          <GeneralInfoPageAccelEtpnReturningv2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />);
        GENERAL_INFO_current_version = (
          <GeneralInfoPageAccelEtpnReturningv2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        break;

      case AccelEtpnReturningMultiV1:
        IQ_current_version = <div>none</div>
        INSTRUCTIONS_current_version = (
          <GeneralInfoPageAccelEtpnReturningMultiFundv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />);
        GENERAL_INFO_current_version = (
          <GeneralInfoPageAccelEtpnReturningMultiFundv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        break;

      case LPMULTIFUNDV1:
        IQ_current_version = (
          <QuestionnairePageLPMultiFundv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsLPMultiFund {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPMultiFundv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
      case LPMULTIFUNDV2_1:
      case LPMULTIFUNDV2:
        IQ_current_version = (
          <QuestionnairePageLPMultiFundv2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsLPMultiFundv2 {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPMultiFundv2
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

       case LPMULTIFUNDV3:
        IQ_current_version = (
          <QuestionnairePageLPMultiFundv3
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsLPMultiFundv3 {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPMultiFundv3
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case LPMULTIFUNDV4:
        IQ_current_version = (
          <QuestionnairePageLPMultiFundv4
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsLPMultiFundv4 {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPMultiFundv4
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case LPMULTIFUNDV5:
      case LPMULTIFUNDV6:
        IQ_current_version = (
          <QuestionnairePageLPMultiFundv5
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsLPMultiFundv5 {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPMultiFundv5
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
      case LPMULTIFUNDV7:
        IQ_current_version = (
          <QuestionnairePageLPMultiFundv7
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsLPMultiFundv7 {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLPMultiFundv7
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case AudereV1:
        IQ_current_version = (
          <QuestionnairePageAuderev1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageAudere {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageAuderev1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case AudereV2:
        IQ_current_version = (
          <QuestionnairePageAuderev2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageAudere {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageAuderev2
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

       case AudereV3:
       case AudereV4:
        IQ_current_version = (
          <QuestionnairePageAuderev3
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPageAudere {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageAuderev3
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
        
      case LimitedPartnershipMFV1:
        IQ_current_version = (
          <QuestionnairePageLimitedPartnershipMFv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsLimitedPartnershipMF {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLimitedPartnershipMFv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case LimitedPartnershipMFV2:
      case LimitedPartnershipMFV2_1:
        IQ_current_version = (
          <QuestionnairePageLimitedPartnershipMFv2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsLimitedPartnershipMF {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLimitedPartnershipMFv2
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;
      
       case LimitedPartnershipMFV3:
        IQ_current_version = (
          <QuestionnairePageLimitedPartnershipMFv3
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsLimitedPartnershipMF {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLimitedPartnershipMFv3
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case LimitedPartnershipMFV4:
        IQ_current_version = (
          <QuestionnairePageLimitedPartnershipMFv4
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsLimitedPartnershipMF {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLimitedPartnershipMFv4
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case LimitedPartnershipMFV5:
      case LimitedPartnershipMFV6:
      case LimitedPartnershipMFV6_SparkCapital:
        IQ_current_version = (
          <QuestionnairePageLimitedPartnershipMFv5
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsLimitedPartnershipMF {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLimitedPartnershipMFv5
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case LimitedPartnershipMFV7:
        IQ_current_version = (
          <QuestionnairePageLimitedPartnershipMFv7
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsLimitedPartnershipMF {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageLimitedPartnershipMFv7
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case BenchmarkMultiFundV1:
        IQ_current_version = (
          <QuestionnairePageBenchmarkMultiFundv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsBenchmarkMultiFund {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageBenchmarkMultiFundv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case BenchmarkMultiFundV2:
        IQ_current_version = (
          <QuestionnairePageBenchmarkMultiFundv2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsBenchmarkMultiFund {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageBenchmarkMultiFundv2
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case BenchmarkMultiFundV3:
        IQ_current_version = (
          <QuestionnairePageBenchmarkMultiFundv3
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsBenchmarkMultiFund {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageBenchmarkMultiFundv3
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case PictureCapitalV1:
      case PictureCapitalV2:
        IQ_current_version = (
          <QuestionnairePagePictureCapitalv1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPictureCapital {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPagePictureCapitalv1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

      case PictureCapitalV3:
        IQ_current_version = (
          <QuestionnairePagePictureCapitalv3
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsPictureCapital {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPagePictureCapitalv3
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

       case SROneV1:
        IQ_current_version = (
          <QuestionnairePageSROnev1
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsSROne {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageSROnev1
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

        case SROneV2:
        case SROneV3:
        IQ_current_version = (
          <QuestionnairePageSROnev2
            {...commonProps}
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            history={this.props.history}
          />
        );
        INSTRUCTIONS_current_version = <InstructionsSROne {...commonProps} />;
        GENERAL_INFO_current_version = (
          <GeneralInfoPageSROnev2
            updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
            {...commonProps}
          />
        );
        break;

        case TerrariumV1:
        case TerrariumV2:
          IQ_current_version = (
            <QuestionnairePageTerrariumv1
              {...commonProps}
              updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
              history={this.props.history}
            />
          );
          INSTRUCTIONS_current_version = <InstructionsPageTerrarium {...commonProps} history={this.props.history} />;
          GENERAL_INFO_current_version = (
            <GeneralInfoPageTerrariumv1
              history={this.props.history}
              updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
              {...commonProps}
            />
          );
        break;

        case NICFUNDV1:
        case NICFUNDV2:
          IQ_current_version = (
            <QuestionnairePageNICFundv1
              {...commonProps}
              updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
              history={this.props.history}
            />
          );
          INSTRUCTIONS_current_version = <InstructionsNICFund {...commonProps} />;
          GENERAL_INFO_current_version = (
            <GeneralInfoPageNICFundv1
              updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
              {...commonProps}
            />
          );
          break;

        case NICFUNDV3:
          IQ_current_version = (
            <QuestionnairePageNICFundv3
              {...commonProps}
              updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
              history={this.props.history}
            />
          );
          INSTRUCTIONS_current_version = <InstructionsNICFund {...commonProps} />;
          GENERAL_INFO_current_version = (
            <GeneralInfoPageNICFundv3
              updateMultiSelectFormAnswer={this.updateMultiSelectFormAnswer}
              {...commonProps}
            />
          );
          break;
      
      default:
        console.error('IQ version needs to be provided');
        break;
    }

    const pathRender = [ 
      {
        path: '/access/home/instructions',
        exact: true,
        render: INSTRUCTIONS_current_version,
      },
      {
        path: '/access/home/information',
        exact: true,
        render: GENERAL_INFO_current_version,
      },
      {
        path: '/access/home/questionnaire',
        exact: true,
        render: IQ_current_version,
      },
      {
        path: '/access/home/signatures',
        exact: true,
        render: <SignaturesPage {...commonProps} />,
      },
      {
        path: '*',
        component: NotFoundPage,
      },
    ];

    if (IQ_VERSION.includes(AccelV1) || 
        IQ_VERSION.includes(AccelV2) || 
        IQ_VERSION.includes(AccelV3) ||
        IQ_VERSION.includes(AccelV4)) {
        pathRender.splice(1, 0,  
          {
          path: '/access/home/letter',
          exact: true,
          render: INTEREST_LETTER_current_version,
          }
        )
    }

    if (IQ_VERSION.includes(VariantV1) || IQ_VERSION.includes(VariantV2) || IQ_VERSION.includes(VariantV3)) {
        pathRender.splice(3, 0,  
          {
          path: '/access/home/distribution',
          exact: true,
          render: INTEREST_DISTRIBUTION_current_version,
          }
        )
    }

    if (IQ_VERSION.includes(UnionPeakV1) || IQ_VERSION.includes(UnionPeakV2) || IQ_VERSION.includes(UnionPeakV3)) {
         pathRender.splice(3, 0,  
          {
          path: '/access/home/dissolution',
          exact: true,
          render: CONSENT_TO_DISSOLUTION_current_version,
          }
        )
    }

    if (IQ_VERSION.includes(AccelEtpnReturningV1) || IQ_VERSION.includes(AccelEtpnReturningV2)) {
      pathRender.splice(0, 1);
      pathRender.splice(1, 1);
    } 

    if (IQ_VERSION.includes(AltimeterAMLV1)) {
      pathRender.splice(0, 2);
    }

    if ((IQ_VERSION.includes(TerrariumV1) || IQ_VERSION.includes(TerrariumV2))&& terrariumSubscribedPerson === 'yes') {
      pathRender.splice(0, 1);
      pathRender.splice(1, 1);
    }

    return pathRender
      
  };

  // Steppers component & progress bar per IQ version
    renderQuestionnaire = () => {
      const { questionnaireContext } = this.props;
      const IQ_VERSION = 
      questionnaireContext.investorFund && 
      questionnaireContext.investorFund.questionnaire &&
      questionnaireContext.investorFund.questionnaire.iqVersion;

      const terrariumSubscribedPerson = questionnaireContext && questionnaireContext.investorFund && questionnaireContext.investorFund.generalInfo && 
      questionnaireContext.investorFund.generalInfo.terrariumSubscribedPerson ? questionnaireContext.investorFund.generalInfo.terrariumSubscribedPerson : null;

      switch (IQ_VERSION) {
        case AccelEtpnReturningV1:
        case AccelEtpnReturningV2:
        case AccelEtpnReturningMultiV1:
          return {
            QuestionnaireStepper: QuestionnaireStepsAccelEtpnReturning,
            ProgressBar: ProgressAccelEtpnReturning,
          }
        case AltimeterAMLV1:
          return {
            QuestionnaireStepper: QuestionnaireStepsAltimeterAML,
            ProgressBar: ProgressAccelEtpnReturning,
          }
        case VariantV1:
        case VariantV2:
        case VariantV3:
          return {
            QuestionnaireStepper: QuestionnaireStepsVariant,
            ProgressBar: ProgressVariant,
          }
        case UnionPeakV1:
        case UnionPeakV2:
        case UnionPeakV3:
          return {
            QuestionnaireStepper: QuestionnaireStepsUnionPeak,
            ProgressBar: ProgressUnionPeak,
          }
        case AccelV1:
        case AccelV2:
        case AccelV3:
        case AccelV4:  
          return {
            QuestionnaireStepper: QuestionnaireStepsAccel,
            ProgressBar: ProgressAccel,
          }
        case TerrariumV1:
        case TerrariumV2:
          return terrariumSubscribedPerson  === 'yes' ? {
            QuestionnaireStepper: QuestionnaireStepsAccelEtpnReturning,
            ProgressBar: ProgressAccelEtpnReturning,
          } : {
             QuestionnaireStepper: QuestionnaireSteps,
             ProgressBar: Progress,
          }
        default:
          return {
            QuestionnaireStepper: QuestionnaireSteps,
            ProgressBar: Progress,
          }
      }
    }

    



  renderHomeRoutes = (saving) =>
    saving ? (
      <div className="loader">
        <Switch>
          {this.accessHomeRoutes().map((route) =>
            this.routeWithSubRoutes(route)
          )}
        </Switch>
      </div>
    ) : (
      <Switch>
        {this.accessHomeRoutes().map((route) => this.routeWithSubRoutes(route))}
      </Switch>
    );

  routeWithSubRoutes = (route) => (
    <Route
      key={_.uniqueId()}
      exact={route.exact || false}
      path={route.path}
      render={(props) =>
        route.component ? (
          <route.component {...props} routes={route.routes} />
        ) : (
          route.render
        )
      }
    />
  );
  handleBrowserClose = (e) => {
    e.preventDefault();
  };

  render() {
    const { questionnaireContext } = this.props;
    const { QuestionnaireStepper, ProgressBar } = this.renderQuestionnaire();

    if (questionnaireContext.initializationComplete) {
      return (
        <Beforeunload onBeforeunload={this.handleBrowserClose}>
          <div className="main-container">
            <div className="container">
              <Helmet title="Fund Flow Home" />

              <ProgressBar step={questionnaireContext.currentStep} />
              <QuestionnaireStepper
                currentStep={questionnaireContext.currentStep}
                clickHandler={this.triggerNextStep}
              /> 

              {/* fixme savingGeneral Info may need a proper naming to be more generic */}
              {questionnaireContext.currentVersionInitialized ? (
                this.renderHomeRoutes(questionnaireContext.savingGeneralInfo)
              ) : (
                <p>...</p>
              )}
            </div>
            {questionnaireContext.questionnaireAccessExpired ? (
              <ReactConfirmAlert
                title="Session Expired"
                message="Your IQ access has expired. Please log back in."
                confirmLabel="Accept"
                cancelLabel="Cancel"
                onConfirm={this.handleIQAccessExpiration}
                onCancel={this.handleIQAccessExpiration}
              />
            ) : null}
            <Popup
              data={{
                id: 'saveLaterPopup',
                popupType: 'info',
                title: 'Progress Saved',
              }}
              leaveAction={this.leaveQuestionnaire}
            />
            <a
              href="#/"
              className="hidden"
              data-dismiss="modal"
              ref={(close) => {
                this.closeButton = close;
              }}
            >
              Close popup
            </a>
          </div>
        </Beforeunload>
      );
    }
    return (
      <Redirect
        to={{
          pathname: '/access/login',
        }}
      />
    );
  }
}

/**
 * @param {Gunderson.Reducer} state
*/

const mapStateToProps = (state) => ({
  questionnaireContext: state.questionnaireExperience,
});

/**
 * @type {Gunderson.Connector<{}, Props>}
*/
const connector = connect(
  mapStateToProps,
  /**
   * @param {Gunderson.Dispatch} dispatch
  */
  (dispatch) => ({
    logQuestionnaireError: (_error, _context) =>
      handleQuestionnaireError(_error, _context, dispatch),
    setVersion: (_version) =>
      dispatch({ type: IQ_SET_CURRENT_VERSION, currentVersion: _version }),
    setVersionQuestions: (_versionQuestions) =>
      dispatch({
        type: IQ_SET_CURRENT_VERSION_QUESTIONS,
        currentVersionQuestions: _versionQuestions,
      }),
    setFund: (_fund) => dispatch({ type: IQ_SET_FUND, fund: _fund }),
    setSignaturesMethod: (_method) =>
      dispatch({ type: IQ_SET_SIGNATURES_METHOD, signaturesMethod: _method }),
    setInvestor: (_investor) =>
      dispatch({ type: IQ_SET_INVESTOR, investor: _investor }),
    setInvestorFund: (_investorFund) =>
      dispatch({ type: IQ_SET_INVESTOR_FUND, investorFund: _investorFund }),
    setCurrentStep: (_step) =>
      dispatch({ type: IQ_SET_CURRENT_STEP, currentStep: _step }),
    setMultiSelectFormMetadata: (_metadata) =>
      dispatch({
        type: IQ_SET_MULTI_SELECT_FORM_METADATA,
        multiSelectFormMetadata: _metadata,
      }),
    isQuestionnaireExpired: (_expired) =>
      dispatch({
        type: IQ_SHOW_EXPIRATION_NOTICE,
        questionnaireAccessExpired: _expired,
      }),
    setSavingInfo: (_saving) =>
      dispatch({
        type: IQ_SET_TRIGGER_GENERAL_INFORMATION,
        updateGeneralInformationTrigger: _saving,
      }),
    isSignaturesEnabled: (_enabled) =>
      dispatch({ type: IQ_IS_SIGNATURES_ENABLED, signaturesEnabled: _enabled }),
    isNaturalPerson: (_is) =>
      dispatch({ type: IQ_IS_NATURAL_PERSON, isNaturalPerson: _is }),
    setValidationRequiredParts: (_requiredItems) =>
      dispatch({
        type: IQ_SET_VALIDATION_REQUIRED_PARTS,
        missingQuestionnaireParts: _requiredItems,
      }),
    showSignaturesInstructions: (_show) =>
      dispatch({
        type: IQ_SHOW_SIGNATURE_INSTRUCTIONS,
        showInstructionsModal: _show,
      }),
    renderNotification: (_type, _title, _message) =>
      dispatch({
        type: 'RENDER_NOTIFICATION',
        notificationType: _type,
        message: _message,
        title: _title,
      }),
    getFundById: (firmId, callback) =>
      dispatch(action.getFundById(firmId, callback)),
    // new items added above
  })
);
export default withRouter(connector(QuestionnaireExperienceHome));
